export const English = {
  lang: 'en',
  wizard: {
    createAccount: 'Create new account',
    noCreditCard: 'No credit card needed, cancel any time',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    role: 'Role',
    dialCode: 'Country',
    fullNumber: 'Country and phone number',
    password: 'Password',
    saveButton: 'Send',
    captchaError: 'Captcha has not been validated',
    inputError: 'Complete field',
    emailExistsError: 'Email address is already in use',
    passwordError: 'Must be at least 6 characters long',
    emailError: 'Invalid email',
    emailInfo: 'With this email you can login into app and web platform',
    privacyMessage: 'Upon clicking you agree that you accept our ',
    privacy: 'Privacy Policy',
    preparingForm: 'We are creating your account and preparing the form',
    preparingForm2: 'This could take a few seconds',
    preparingForm3: 'We are preparing the form',
    userHasAccount: 'Already have an account?',
    login: 'Login',
    onboardingVideo:
      'Watch this brief video and discover how Datascope can transform your processes and make your work easier',
    onboardingVideoTitle: 'What can Datascope do for you?',
    onboardingVideoSkip: 'Continue',
    onboardingResetModal: {
      title: 'Aún no terminas de configurar tu cuenta',
      message:
        'No terminaste de configurar tu cuenta. ¿Quieres continuar donde la dejaste o empezar desde cero?',
      cancelButtonText: 'Comenzar de nuevo',
      confirmButtonText: 'Continuar',
      error: 'Error resetting account information',
    },
    onboardingLogoutModal: {
      title: 'Are you sure you want to logout from the onboarding process?',
      message: 'If you logout, you can resume the onboarding process later by logging in again.',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Logout',
    },
    back: 'Back',
    intro: "Hello! Let's start with the basics",
    introDescription:
      'Help us get to know you better so we can personalize your experience and offer you exactly what you need.',
    companyName: 'Your company name',
    industry: 'Your industry',
    phoneNumber: 'Your phone number',
    next: 'Next',
    firstNameError: 'First name is required',
    lastNameError: 'Last name is required',
    companyNameError: 'Company name is required',
    industryError: 'Industry is required',
    phoneNumberError: 'Phone number must have at least 8 digits',
    noResults: 'No results',
    searchCountry: 'Search country...',
    selectOption: 'Select an option',
    namePlaceholder: 'Write your name',
    companyPlaceholder: 'Write your company name',
    search: 'Search',
    formErrors: 'Please complete all required fields',
    industries: {
      agriculture: 'Agriculture',
      food: 'Food',
      automotive: 'Automotive',
      construction: 'Construction',
      consulting: 'Consulting',
      energy: 'Energy',
      facility: 'Facility Services',
      forestry: 'Forestry',
      engineering: 'Engineering',
      cleaning: 'Cleaning and Maintenance',
      logistics: 'Logistics',
      machinery: 'Machinery',
      manufacturing: 'Manufacturing',
      mining: 'Mining',
      retail: 'Retail',
      public: 'Public Sector',
      environment: 'Environmental Services',
      health: 'Health Services',
      communication: 'Telecommunications',
      transport: 'Transportation and Loading',
      wine: 'Wine',
    },
    roles: {
      management: 'Management',
      consulting: 'Consulting',
      owner: 'Owner',
      leadership: 'Leadership',
      student: 'Student',
      independent: 'Independent',
      analyst: 'Analyst',
      other: 'Other',
    },
    roleRequired: 'Please select a role',
    roleQuestion: 'Now tell us, what is your role in the organization?',
    roleQuestionDescription: 'This will help us provide you with a better experience',
    areas: {
      security: 'Security and hygiene',
      quality: 'Quality',
      operations: 'Operations/Services (WO/SO)',
      audit: 'Audit',
      general: 'General use',
    },
    areaRequired: 'Please select an area',
    areaQuestion: 'In which area would you like to focus today?',
    areaQuestionDescription: 'Select the area that most interests you',
    selectOptions: 'Select the options that interest you',
    selectRequired: 'Please select at least one option',
    interests: {
      security: {
        question: 'What would you like to manage in security and hygiene?',
        options: {
          register_talks: 'Register talks',
          fatality_risks: 'Fatality risks',
          risks_matrices: 'Risk matrices',
          safety_work_analysis: 'Safety work analysis',
          accidents: 'Accidents and incidents',
          inspection_checklist: 'Inspection checklist',
          training_records: 'Training records',
        },
      },
      quality: {
        question: 'What aspect of quality would you like to manage?',
        options: {
          standard_procedures: 'Standard Operating Procedures (SOP)',
          preoperational_verifications: 'Pre-operational verifications',
          quality_control: 'Quality control',
          audit_plans: 'Audit plans',
          non_conformity_records: 'Non-conformity records',
          legal_records: 'Legal records',
        },
      },
      operations: {
        question: 'What operations would you like to manage?',
        options: {
          maintenance_programs: 'Maintenance programs',
          calibrations: 'Calibrations',
          installations: 'Installations',
          failure_records: 'Failure records',
          daily_reports: 'Daily reports',
          certifications: 'Certifications',
          warranties: 'Warranties',
          consumption_records: 'Consumption records',
          progress_records: 'Progress records',
        },
      },
      audit: {
        question: 'What type of audit would you like to manage?',
        options: {
          quality_audits: 'Quality audits',
          safety_audits: 'Safety and hygiene audits',
          equipment_audits: 'Equipment audits',
          norms_compliance: 'Compliance with norms',
          register_audits: 'Audit records',
          performance_evaluations: 'Performance evaluations',
        },
      },
      general: {
        question: 'What general functionality would you like to use?',
        options: {
          polls: 'Polls',
          inventory: 'Inventory control',
          attendance: 'Attendance control',
        },
      },
    },
    moreThan: 'More than',
    selectOneOption: 'Please select one option',
    personnelCount: 'Currently, how many people work on this process?',
    personnelCountDescription: 'Select the number of people who will use the platform',
    complete: 'Finish',
  },
  wizardFinish: {
    buildYourFirstForm: 'Build your first form',
    yourPick: 'Your pick',
    formTemplates: 'Form templates',
    createForm: 'Create form from scratch',
    importForm: 'Import Google Form',
    welcome: 'Welcome!',
    welcomeDescription1: 'Starting now, you can ',
    welcomeDescription2:
      'use the Web App and the Mobile App using the credentials you just entered.',
    welcomeDescription3:
      'Remember, to begin collecting data, simply download the App from App Store or Play Store on your phone or tablet.',
  },
  onboardingTemplates: {
    title: 'We recommend these forms based on your use',
    subtitle: 'Select one to start working immediately',
    answerNow: 'Answer now',
    exploreOthers: 'Explore other templates',
    aiFormBuilderCta: 'Create your form with AI in seconds.',
    aiFormBuilderLink: 'Open AI form builder',
    aiFormBuilderTitle: 'Create your form with AI in seconds',
    aiFormBuilderSubtitle: 'Describe the form you need and our agent will create it in seconds.',
    aiFormBuilderButton: 'Create with AI',
    recentlyViewedLabel: 'Recently viewed',
    aiFormBuilderRecommendationsTitle: 'Recommendations you can create and use',
    aiFormBuilderNoMatchText: "Can't find the right one?",
    aiFormBuilderNoMatchButton: 'Create a custom form with AI',
  },
  task_assigner: {
    only_once: 'Only once',
    working_days: 'Working days',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    custom: 'Custom',
    task_frequency: 'Task frequency',
    task_frequency_info: 'The task frequency option is available only when assigning a single date',
    assigned: 'Assigned',
    completed: 'Completed',
    pending: 'Accepted',
    incomplete: 'Incomplete',
    states: {
      completed: 'Completed',
      inProgress: 'Accepted',
      pending: 'Pending',
      incomplete: 'Incomplete',
      rejected: 'Rejected',
      scheduled: 'Scheduled',
      sent: 'Assigned',
    },
    cards: {
      totalTasks: 'Total tasks',
      completed: 'Completed',
      pending: 'Accepted',
      incomplete: 'Incomplete',
      rejected: 'Rejected',
      scheduled: 'Scheduled',
      sent: 'Assigned',
    },
    your_assigned_tasks: 'Your assigned tasks',
    filtersTitle: 'Filters',
    filters: {
      clearFilters: 'Clear filters',
      dateRange: {
        title: 'Date',
        popoverTitle: 'Filter by execution date',
      },
      location: {
        title: 'Location',
        popoverTitle: 'Filter by location',
        noLocations: 'No locations found',
      },
      form: {
        title: 'Form',
        popoverTitle: 'Filter by forms',
        inactive: 'Inactive',
        deleted: 'Deleted',
        forms: 'Forms',
        folders: 'Folders',
        noForms: 'No forms found',
      },
      status: {
        title: 'Status',
        popoverTitle: 'Filter by status',
      },
      user: {
        title: 'Users',
        popoverTitle: 'Filter by users',
        noUsers: 'No users found',
        noGroups: 'No groups found',
        deactivated: 'Deactivated',
        allTab: 'Users',
        groupTab: 'Groups',
      },
      taskId: {
        title: 'Task ID',
        popoverTitle: 'Filter by task ID',
        label: 'Task ID',
        placeholder: 'Enter the ID',
      },
    },
    searchBarPlaceholder: 'Search by form name...',
    new_task: 'New Task',
    edit_task: 'Edit Task',
    createForm: {
      title: 'Create new task',
      usersField: {
        label: 'Users',
        addCta: '+ Add users',
        addCtaMore: '+ Add users',
      },
      usersDrawer: {
        title: 'Add users',
        searchPlaceholder: 'Search user',
        tabs: {
          users: 'Users',
          groups: 'Groups',
        },
        allUsersLabel: 'Users',
        noUsersFound: 'No users found',
        noGroupsFound: 'No groups found',
        close: 'Close',
      },
      formsField: {
        label: 'Forms',
        addCta: '+ Select forms',
        addCtaMore: '+ Select forms',
      },
      formsDrawer: {
        title: 'Forms',
        infoBanner: 'If you select multiple forms, you will create multiple tasks with the selected ones',
        searchPlaceholder: 'Search form, folder...',
        tabs: {
          forms: 'Forms',
          folders: 'Folders',
        },
        noForms: 'No forms found',
        deleted: 'Deleted',
        inactive: 'Inactive',
        close: 'Close',
      },
      otherFields: {
        locationLabel: 'Location',
        locationPlaceholder: 'Select a location',
        assetLabel: 'Asset',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Write a task description',
      },
      subtasksField: {
        label: 'Tasks to do',
        placeholder: 'Write a task',
        addCta: '+ Add task',
        enterHelper: 'Press Enter to add another task',
        removeAriaLabel: 'Remove task',
      },
      infoContainer: {
        title: 'Task information',
        subtitle: 'Define the general task details, assignees and where it will be performed.',
      },
      scheduleContainer: {
        title: 'Date and time',
        subtitle: 'Define when the task will be performed and how long it will be available.',
        dateFieldLabel: 'Date and time',
        gapFieldLabel: 'Task duration in hours',
        gapPlaceholder: 'e.g. 24',
        lateResponseLabel: 'Allow response after the due date',
        duration: {
          prefix: 'Duration: ',
          year: 'year',
          years: 'years',
          month: 'month',
          months: 'months',
          week: 'week',
          weeks: 'weeks',
          day: 'day',
          days: 'days',
          hour: 'hour',
          hours: 'hours',
          and: 'and',
        },
      },
      participationContainer: {
        title: 'Participation',
        subtitle:
          'Indicate whether the task must be answered mandatorily or whether users can decide to perform it.',
        mandatoryTitle: 'Mandatory',
        mandatoryDescription: 'All users must respond to the task',
        voluntaryTitle: 'Voluntary',
        voluntaryDescription: 'All users can accept/reject the task',
      },
      remindersContainer: {
        title: 'Reminders',
        subtitle: 'Notifications will be sent automatically based on the task due date.',
        question: 'How long before the due date would you like to receive a reminder?',
        channelsLabel: 'Notification channel',
        disabledChipTooltip:
          'This option cannot be selected given the current task date and time configuration',
        timePresets: {
          min15: '15 min',
          min30: '30 min',
          hour1: '1 hour',
          day1: '1 day',
          day3: '3 days',
          week1: '1 week',
        },
        channels: {
          notification: 'In-app notification',
          email: 'Email',
        },
      },
    },
    tasks: 'Tasks',
    massive_search: 'Search by user, form or place ...',
    user: 'User',
    form: 'Form',
    place: 'Place',
    date: 'Date',
    date_and_time: 'Date and Time',
    gap: 'Gap',
    state: 'State',
    save: 'Save',
    users: 'Users',
    description: 'Description',
    hour: 'Hour',
    alert: 'alert',
    delete: 'Delete',
    cancel: 'cancel',
    accept: 'agree',
    notify: 'Notify',
    notify_user: 'Do you want to notify to ',
    sure: 'Are you sure?',
    delete_task: 'You will delete a task',
    delete_tasks: 'Do you want to delete this tasks: ',
    reset: 'Reset',
    old_version: 'Old Version',
    task_created: 'Task Created',
    our_problem: 'We have problem',
    task_update: 'Task updated successfully',
    export: 'Export',
    date_necessary: 'A date is required',
    required: 'Required',
    blanck: 'There are empty fields',
    notification_sent: 'Notification sent successfully',
    notifications_sent: 'Notifications sent successfully',
    tasks_delete: 'Tasks deleted successfully. Please wait a few seconds for them to be reflected',
    task_delete: 'Task deleted successfully',
    new_place: 'New Place',
    start: 'Start',
    end: 'End',
    history: 'History',
    actions: 'Actions',
    dobleClick: 'Double click on task = open details',
    shiftMouse: 'shift + mousewheel = move timeline left/right',
    altMouse: 'alt + mousewheel = zoom in/out',
    timeline: 'Timeline',
    taskAssignID: 'Task assign ID',
    selected_range: 'Selected range',
    notifications: 'Add notifications',
    add_notification: 'Add a notification',
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    notification: 'Notification',
    email: 'Email',
    max_one_date: 'Maximum 1 date in edit mode',
    max_one_user: 'Maximum 1 user in edit mode',
    no_location_warning: 'A location has not been specified, or may have been erased.',
    showing_results_for: 'Showing results for',
    task: 'Task',
    no_tasks_available: 'No tasks available at this moment',
    gap_hours: 'Duration of tasks in hours',
    allow_late_submission: 'Allow the task to be answered after the due date has been reached',
    add_tasks: 'Add tasks',
    add_tasks_caption:
      'You can quickly add tasks by separating them with commas "," or pressing Enter',
    configuration: 'Configuration',
    voluntary_task: 'Make this task voluntary (All users can accept/reject the task)',
    mandatory_task: 'Make this task mandatory (All users must answer to the task)',
    notification_type: 'Notification type',
    notification_time: 'Time',
    notification_period: 'Time period',
    app_notification: 'App notification',
    confirmation_title_prefix: 'Are you sure you want to create ',
    confirmation_title_suffix: ' tasks?',
    confirmation_title_suffix_one: 'tasks for',
    confirmation_title_suffix_two: 'days?',
    edit_confirmation_title: 'Are you sure you want to edit this task?',
    success_message:
      'Tasks created successfully! Please wait a few seconds for them to be reflected. Remember to refresh the page to view them.',
    update_success_message: 'Task updated successfully!',
    forms_info:
      'If you select multiple forms, you will create multiple tasks with the selected ones.',
    asset: 'Asset',
    asset_autocomplete_hint: 'The assigned asset will be auto-filled in the form if applicable',
    filters_asset_title: 'Asset',
    edit: 'Edit',
    show_answer: 'Show answer',
    notify_title: 'Are you sure you want to notify the following user?',
    bulk_notify_title: 'Are you sure you want to notify the following users?',
    delete_title: 'Are you sure you want to delete the following task?',
    delete_description: 'It will be deleted and you will not be able to recover it',
    bulk_delete_title_one: 'Are you sure you want to delete',
    bulk_delete_title_two: 'tasks?',
    bulk_delete_description:
      'If you delete them, they will disappear from the list of pending tasks of the users and they will not be able to answer them',
    bulk_actions: 'Bulk Actions',
    creation_date: 'Creation Date',
    start_date: 'Start Date',
    answers: 'Answers',
    duration: 'Duration:',
    answered: 'answered',
    out_of_time: 'Out of time',
    late: 'late',
    no_location: 'No location',
    task_does_not_exist: 'The task does not exist',
    location_copied: 'Location copied to clipboard',
    completed_tasks_cannot_be_deleted: 'Completed tasks cannot be deleted',
    some_tasks_skipped_due_to_answers:
      '%{count} task(s) were skipped because they already have answers and cannot be deleted',
    no_tasks_were_modified: 'No tasks were modified',
    complete_task: 'Complete task',
    complete_task_description: 'Do you want to complete this task now?',
    complete_task_button: 'Complete',
    reject_task_button: 'Reject',
    accept_task_button: 'Accept',
    accept_reject_confirmation:
      'You can accept it and complete it, or reject it if you cannot perform it.',
    import: {
      title: 'Import Tasks',
      step1Title: 'Step 1: Download template',
      step1Description:
        'Download the Excel template example. Make sure to complete the fields marked with * to import your file correctly.',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Edit the file',
      step2Description:
        'Fill in the template with your task data. Make sure all required fields are completed.',
      step2MoreInfo: 'Learn more here',
      step3Title: 'Step 3: Upload your file',
      step3Description:
        'Drag and drop your file here or select it from your computer. It may take a few minutes to process.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      fileUploadError: 'Your file could not be uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importError: 'Error importing tasks',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      success: 'Tasks imported successfully. Please wait a few seconds for them to be reflected.',
      errorTitle: 'We detected an error.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      baseTemplateUrl: 'https://s3-us-west-2.amazonaws.com/data-scope/templates/',
      templateFileLegacy: `task_assign_en3_v1.xlsx`,
      templateFileV5: `task_assign_en_v5.xlsx`,
      templateFileLegacyV6: `task_assign_en3_v2.xlsx`,
      templateFileV6: `task_assign_en_v6.xlsx`,
      requirements: {
        title: 'File requirements',
        uniqueIds: 'Avoid duplicate ID values.',
        duplicateIdMessage: "ID '{id}' is duplicated. The last value will be used.",
        formNameComplete: "'Form Name' column complete.",
        missingFormNameMessage: "Missing form name in '{cell}'.",
        missingFormNameColumn: "Column 'Form Name' was not found.",
        userEmailComplete: "'User Email' column complete.",
        missingUserEmailMessage: "Missing user email in '{cell}'.",
        missingUserEmailColumn: "Column 'User Email' was not found.",
        dateAndGapComplete: "'Datetime' and 'Time Gap' columns complete.",
        missingStartDateMessage: "Missing start date in '{cell}'.",
        missingStartDateColumn: "Column 'Datetime' was not found.",
        missingGapMessage: "Missing time gap in '{cell}'.",
        missingGapColumn: "Column 'Time Gap' was not found.",
        seeMore: 'See {count} more',
        seeLess: 'See less',
      },
      confirmIncomplete: {
        title: 'Some rows are incomplete',
        body: '{skipped} of {total} row(s) are missing required fields. Those rows will be skipped and {valid} valid row(s) will be imported. Do you want to continue?',
        cancel: 'Cancel',
        confirm: 'Import {valid} row(s)',
      },
      helpUrl: 'https://help.mydatascope.com/en/articles/2852072-how-to-import-tasks-massively',
      errors: {
        invalidFileType: 'Please select a valid Excel file (.xlsx)',
        importError: 'Error importing tasks. Please check that your data has the correct format.',
        templateDownloadError: 'Failed to download template',
        errorTitle: 'We detected an error.',
      },
    },
    import_audit: {
      title: 'Import history',
      tab: 'History',
      menuImportNow: 'Import now',
      menuViewHistory: 'View history',
      genericImportError:
        'There was a problem processing this import. If the issue persists, contact support.',
      taskImportsTab: 'Task imported',
      backToTasks: 'Back to Task Assignments',
      rowsTitle: 'Rows',
      emptyState: 'No recent imports',
      viewDetails: 'View details',
      back: 'Back to history',
      retrySuccess: 'Task created successfully',
      retryError: 'Could not create the task',
      statuses: {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
        created: 'Created',
        updated: 'Updated',
        skipped: 'Skipped',
        resolved_manually: 'Resolved',
      },
      error_codes: {
        task_form_not_found: 'Form not found',
        mobile_user_not_found: 'User not found',
        date_unparseable: 'Invalid date',
        assign_id_in_use: 'ID in use (task in progress or completed)',
        validation_failed: 'Validation error',
      },
      columns: {
        file: 'File',
        date: 'Date',
        triggeredBy: 'Imported by',
        status: 'Status',
        summary: 'Summary',
        rowNumber: 'Row',
        assignId: 'Task ID',
        task: 'Form',
        user: 'User',
        error: 'Error',
        actions: 'Actions',
      },
      summary: {
        read: '%{n} read',
        created: '%{n} created',
        updated: '%{n} updated',
        failed: '%{n} failed',
        skipped: '%{n} skipped',
      },
      fixAndRetry: 'Fix',
      resolvedBy: 'Resolved by',
      resolvedByHelp: 'User who manually fixed and retried this row',
      resolvedAssignId: 'Assigned ID',
      locationCreated: 'Location auto-created',
      idReplaced: 'Requested ID: %{requested} - used: %{used}',
      changedFields: 'Changes',
      fixModal: {
        title: 'Fix row %{row}',
        submit: 'Create task',
        cancel: 'Cancel',
        submitting: 'Creating...',
      },
    },
    exportModal: {
      title: 'Export assigned tasks',
      bannerWithRange: 'Tasks with an execution date within %{from} - %{to} will be exported',
      bannerWithoutRange: 'Tasks matching the current filters will be exported',
      filenameLabel: 'File name',
      filenameHelp: 'You can change the name before exporting',
      cancel: 'Cancel',
      submit: 'Export',
      defaultFilenamePrefix: 'assigned-tasks-export',
    },
    integrations: {
      button: 'Google Sheets',
      title: 'Assigned Tasks Integration',
      gsheetsIntegrationLabel: 'Go to Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'To ensure a proper, private and secure integration, share your document with edit permissions to',
      infoTextPart2: 'editor',
      infoTextPart3: 'only to',
      inputLabel: 'New link',
      inputPlaceholder: 'Enter the document link to integrate',
      optional: '(Optional)',
      save: 'Save',
      cancel: 'Cancel',
      copyUrl: 'URL copied!',
      copyEmail: 'Email copied!',
      created: 'Integration set up successfully!',
      saved: 'Changes saved successfully!',
      deleted: 'Integration removed successfully',
      savingError: 'Error setting up the integration',
      removeTitle: 'Remove the Google Sheets integration?',
      removeBody:
        'The sheet will stop receiving task assignment updates from DataScope. The document in Google Drive will not be deleted.',
      removeConfirm: 'Remove integration',
      removeCancel: 'Cancel',
    },
  },
  form_answer: {
    answer_again: 'Submit another answer',
    success_message: 'We have received your answer correctly',
    submit_button: 'Submit',
    edit_button: 'Edit',
    edit_form: 'Edit form',
    incomplete_edit_alert: 'You must answer all required questions',
    incomplete_submit_alert: "You haven't entered any answer yet",
    error_submit_alert: 'There was an error uploading your answer',
    error_edit_alert: 'There was an error editing your answer',
    sync_pending_message:
      'This response is still synchronizing. Editing will be available in a few moments.',
    no_edit_alert: "You haven't edited the original answer yet",
    no_answer_alert: 'Your answer is empty',
    required_question: 'This question is required',
    no_options: 'No Options',
    invalid_question_type_1: 'Question of type  ',
    invalid_question_type_2:
      'This type of question cannot be answered/edited in our web platform. Please download our mobile application',
    some_invalid_question_types:
      'Warning: This form has question types that are not supported by the web version of DataScope.',
    download_mobile: 'Download our mobile application here',
    download_mobile_link: 'https://datascope.page.link/H3Ed',
    answer_placeholder: 'Your answer',
    simple_text_placeholder: 'Your text answer',
    text_rut_placeholder: 'Your RUT answer',
    text_container_placeholder: 'Your container ID',
    invalidRutError: 'Invalid RUT',
    invalidContainerError: 'Invalid container ID',
    text_email_placeholder: 'Your email answer',
    select_your_date: 'Select a date',
    select_your_datetime: 'Select a datetime',
    select_your_time: 'Select a time',
    datetime_errors: {
      invalidDate: 'Invalid date',
      minDate: 'The date is less than the minimum allowed',
      maxDate: 'The date is greater than the maximum allowed',
    },
    add_repeatable_questions: 'Add another group of questions',
    signature_type: 'Signature',
    photo_type: 'Photo',
    barcode_type: 'Barcode',
    filter_elements: 'Search elements...',
    upload_image: 'Upload Image',
    no_image_loaded: 'No image has been uploaded yet',
    image_max_size_exceeded: 'One or more of your files exceed the maximum allowed size of',
    image_max_amount_exceeded_part_one: 'You can upload up to',
    image_max_amount_exceeded_part_two: 'images per comment',
    image_upload_error: 'There was an error uploading the files, please try again',
    no_signature_loaded: 'No signature has been uploaded yet',
    save_canvas: 'Save',
    clear: 'Clear',
    modify_signature: 'Modify',
    next: 'Next',
    previous: 'Back',
    upload_file: 'Upload File',
    uploading_file: 'Uploading...',
    unsupported_file_type: 'This file type is not allowed in this question',
    exceeded_max_number_files:
      'You have exceeded the maximum number of files allowed for this question',
    download_app_suggestion: 'Looking for a better and faster way to answer your forms?',
    confirm_section_change:
      "This section has a required question which you haven't answered correctly yet. Do you want to continue anyway?",
    load_more_data: 'Load more data',
    no_data_left: 'There is no data left to load',
    clear_all: 'Clear all',
    no_header_warning:
      'The creator of this question did not specify the list headers for the related lists.',
    more_answers_alert: 'Scroll to see more',
    subform_limit: 'Question group limit reached',
    subform_min: 'Please add the minimum number of answers',
    multi_option_placeholder: 'Select an option',
    locked_asset_hint: 'This asset was assigned in the task',
    image: 'Image',
    download: 'Download',
    multiple_options: 'Select multiple options',
    group: 'Group',
    start: 'Start',
    end: 'End',
    invalid_date: 'Invalid date',
    invalid_time: 'Invalid time',
    locationUpdate: {
      description: 'You must select to change its location',
      lastLocationLabel: 'Last location',
      currentLocationLabel: 'Current location',
      currentLocationPlaceholder: 'Select a location',
    },
    optionComments: {
      addNote: 'Add a note',
      removeNote: 'Remove note',
      writeComment: 'Write a comment',
      requiredNote: 'Comment required',
      addNoteMobile: 'Note',
      addImage: 'Attach Image',
      addImageMobile: 'Image',
      removeNoteMobile: 'Remove',
      requiredImage: 'Image required',
      requiredFinding: 'Finding required',
      deleteImageWarningTitle: 'Are you sure you want to delete this image?',
      deleteImageWarningSubTitle: "Once you delete it, you won't be able to get it back",
      cancel: 'Cancel',
      delete: 'Delete',
    },
    drag_drop_file: 'Drag and drop your files here',
    or_browse_for_file: 'or browse for them on your computer',
    missingRequiredAnswersAlert:
      'Oops! It seems there are still some questions left to answer. Please complete all the required questions to proceed.',
    totalPercentage: 'Total percentage',
    enterSampleTotal: 'Enter the sample total',
    forbidden_access:
      "It seems you don't have permission to edit this form. Request it to make changes",
    automated_signature_on_response:
      'This form has automatic signature configured. The request will be sent to the users assigned when the form is finished.',
    electronic_signature: 'Electronic signature',
    sign_now: 'Sign now',
    sign_later: 'Sign later',
    sign_modal_description: 'This form requires your signature, do you want to sign now?',
    signature_creation_failed: 'There was an error signing the form',
    saveSuccessAndRedirect: 'Answer saved correctly! Redirecting to your signatures...',
    saveAndSignSuccessAndRedirect:
      'Answer saved and signed correctly! Redirecting to your signatures...',
    subtasks: 'Tasks',
    editingActivity: 'Editing activity',
    selectActivityAndDuration: 'Select activity and duration',
    update: 'Update',
    add: 'Add',
    to: 'to',
    activityPlaceholder: 'Activity',
    durationPlaceholder: 'Duration',
    durationExceedsLimit: 'The duration exceeds the remaining time',
    cancel: 'Cancel',
    requiredQuestionIncomplete: 'All working time must be allocated',
    deleteActivityMessage: 'Are you sure you want to delete this activity?',
    allActivitiesRegistered: 'All time allocated',
    workingTimeNotSet: 'Working time not set',
    remainingTimePrefix: 'You still need to assign',
    activityNotSelected: 'Activity missing',
    editActivity: 'Edit',
    insertBelow: 'Insert below',
    deleteActivity: 'Delete',
    addActivity: 'Add Activity',
    leave_form_title: 'You are leaving the form',
    leave_form_message:
      'You have unsaved changes in this response. If you leave this view now, your changes will be lost. Do you want to leave and discard them?',
    leave_stay_button: 'Keep editing',
    leave_confirm_button: 'Leave and discard',
    exit_form_title: 'Exit incomplete form',
    exit_form_message: 'Are you sure you want to leave the form?',
    exit_cancel_button: 'Cancel',
    exit_confirm_button: 'Yes',
    draft_found_title: 'Draft found',
    draft_found_message:
      'You have saved answers from a previous session on this form. How would you like to continue?',
    draft_continue_button: 'Continue with draft',
    draft_start_fresh_button: 'Start a new one',
    draft_recovered_banner:
      'Draft recovered. Please check the attachments and signature fields if applicable.',
    noAssignedLocations:
      'You have no assigned locations for this form. Contact your administrator.',
  },
  percentage: 'Percentage',
  date_fns: 'enGB',
  build_your_own_form: 'Build your own form with DataScope',
  back_to_taskForms: 'Return to form list',
  ok: 'OK',
  yes: 'Yes',
  no: 'No',
  insert_value: 'Insert a value',
  and: 'And',
  invalidEmail: 'Invalid Email',
  group: 'Group',
  folder: 'Folder',
  users: 'Users',
  forms: 'Forms',
  clearAll: 'Clear All',
  actions: 'Actions',
  select: 'Select',
  selectAll: 'Select All',
  form_builder: {
    formName: 'Form name',
    saveForm: 'Save',
    title: 'Title',
    titleDescription: 'Short title to identify the question. Appears when exporting data.',
    instruction: 'Description',
    instructionDescription:
      'Longer text to display in the app. Does not appear when exporting data (Optional).',
    questionType: 'Change question type',
    copy: 'Duplicate question',
    delete: 'Delete question',
    add: 'Add new question',
    advanced: 'Advanced Options',
    type: 'Type',
    date: 'Date',
    dateAndTime: 'Date and Time',
    time: 'Time',
    alternativeColumns: 'Alternative columns',
    addOption: 'Add option',
    dataListSource: 'Data list source',
    changeDataList: 'Change data list',
    listValues: 'List values',
    addListValue: 'Add list value',
    deleteAlternative: 'Delete alternative',
    required: 'Required',
    validateRutChile: 'RUT (Chile)',
    validateMail: 'E-mail',
    validateContainer: 'Container ID',
    validate: 'Validate',
    codeType: 'Change code type',
    disableGallery: 'Disable gallery',
    maxImagesPerItem: 'Max images per item',
    moveUp: 'Move up',
    moveDown: 'Move down',
    alternative: 'Alternative',
    snackBarShared: 'invitations sent',
    snackBar: 'Your form has been saved successfully!',
    activityStartTimeRequired: 'Define the start time of the workday to continue.',
    newListData: 'New List Of Data',
    section: 'Add Section',
    sectionName: 'Unnamed section',
    duplicateSection: 'Duplicate section',
    deleteSection: 'Delete section',
    delSectionsQuestions: 'Delete section and questions',
    areYouSure: 'Are you sure?',
    cancel: 'Cancel',
    sectionAlertOne:
      'The section will be removed, but the questions will be added to the previous section.',
    sectionAlertTwo: 'The section will be deleted and also the questions inside it.',
    yesDelete: 'Yes, delete',
    questionAlert: 'This question will be permanently removed',
    copyName: 'Copy',
    nameAlert: 'The questions must have different names.',
    isRepeated: 'is repeated.',
    if: 'if',
    is: 'is',
    to: 'to',
    goTo: 'go to',
    sectionNameTag: 'Section name',
    skipQuestions: 'Skip questions',
    equal: 'equal',
    dif: 'different',
    contains: 'contains',
    notContains: 'does not contain',
    empty: 'empty',
    notEmpty: 'not empty',
    skipOnlyMobile: 'Only applies for mobile use',
    disableSkip: 'This question type does not support skip logic.',
    next: 'next question',
    end: 'finish form',
    payingAlert:
      'This functionality is not available in the free plan, you must activate your plan in the configuration / billing.',
    showPercent: 'Show percent',
    showSamplingPercent: 'Show sampling percent',
    showPrice: 'Show price',
    showAvg: 'Show average',
    showFactor: 'Show factor',
    camQuality: 'Camera quality',
    high: 'High',
    mid: 'Mid',
    low: 'Low',
    recommended: 'recommended',
    photoAlert: 'synchronization might take longer',
    sectionNameAlert: 'There should be no sections with the same name. Please rename the section: ',
    formatType: 'Format types',
    audioDuration: 'Audio duration',
    secondsLabel: 'seconds',
    cannotCombineWithVoiceAudioRecording: 'Cannot be combined with audio recording',
    anyIncludeAllFormatsExceptVoiceAudioRecording:
      'Any includes all file types, except audio recording',
    voiceAudioRecording: 'Audio recording',
    any: 'Any',
    howToCreate: 'How to create forms',
    good: 'Good',
    regular: 'Regular',
    bad: 'Bad',
    newOption: 'New option',
    moveSection: 'Move section',
    oldShareForm: 'Share this form with a public link',
    shareForm: 'Form Link',
    shareEmail: 'Share by email',
    shareWhatsapp: 'Share by WhatsApp',
    shareWhatsappMessage: 'Share your form with a message by WhatsApp',
    shareWhatsappMessageApi: 'Hi, I invite you to complete the {form_name} form: ',
    formMadePublic: 'The public form link has been enabled',
    undoFormPublic: 'The public form link has been disabled',
    shareForm2: 'Share this form',
    shareFormTip:
      'Anyone, registered users and non-registered persons alike, will be able to fill out this web form if you share the public link with them. Their answers will be registered under the name of a generic user.',
    shareFormOn: 'Make this form public',
    shareFormOff: 'Remove public access',
    shareViaEmailTip: 'Include more emails with enter, space or comma',
    quantity: 'Maximum number of files',
    new: 'New!',
    warning: 'Temporarily only available for web forms',
    testYourForm1: 'Download our official App at ',
    testYourForm2: 'Later you can log in with these same credentials.',
    testYourForm3: 'Test your form on our app!',
    testYourForm4: 'Scan this QR code with your cellphone camera to view your form!',
    testYourForm5:
      'Scan this QR code with your cellphone camera to download our app and view your form!',
    copyLink: 'Copy link',
    visitForm: 'Visit',
    copiedLink: 'Copied!',
    accessYourForm: 'Access your form here',
    downloadApp: 'Download our app',
    ok: 'ok',
    and: 'and',
    greater: 'Greater than',
    greaterOrEqual: 'Greater than or equal to',
    less: 'Less than',
    lessOrEqual: 'Less than or equal to',
    between: 'Between',
    notBetween: 'Not between',
    betweenQuestionOffset: 'Between question and offset',
    dateValidation: {
      addValidation: 'Add validation',
      validationType: 'Validation type',
      fixedRange: 'Fixed range',
      fixedRangeDescription: 'In relation to the answer date',
      fixedRangeDescriptionTime: 'In relation to the answer time',
      relativeRange: 'Relative range',
      relativeRangeDescription: 'In relation to another date question in the form',
      relativeRangeDescriptionTime: 'In relation to another time question in the form',
      rangeCondition: 'Temporal condition',
      selectRangeCondition: 'Select an option',
      predefinedConditions: 'Predefined',
      customConditions: 'Custom',
      offset: 'Offset',
      hours: 'hours',
      days: 'days',
      day: 'day',
      hour: 'hour',
      timeModeWarning:
        'Time does not consider day changes. Use Date and time for ranges between days.',
      minimumValue: 'Minimum value',
      maximumValue: 'Maximum value',
      and: 'and',
      minimumValueForOffsetIs: 'The minimum allowed offset is',
      maximumValueForOffsetIs: 'The maximum allowed offset is',
      onlyToday: 'Only today',
      noFutureDates: 'Do not allow future dates',
      noPastDates: 'Do not allow past dates',
      onlyCurrentTime: 'Only current time',
      noFutureTimes: 'Do not allow future times',
      noPastTimes: 'Do not allow past times',
      after: 'After',
      afterOrEqual: 'After or equal to',
      before: 'Before',
      beforeOrEqual: 'Before or equal to',
      between: 'Between',
      notBetween: 'Not between',
      rangeValidationErrorMessageForDate: 'The value must be at least 1 day.',
      rangeValidationErrorMessageForTime: 'The value must be between 1 and 23 hours.',
      rangeValidationErrorMessageForDateTime: 'The value must be at least 24 hours.',
      date_only_today: "Select today's date.",
      date_no_future: 'Enter a date equal to or before today.',
      date_no_past: 'Enter a date equal to or after today.',
      date_after_tomorrow: "Enter tomorrow's date.",
      date_after_days:
        'Enter a date from tomorrow to the next {{numOfOffsetDays}} {{stringOfOffsetDays}}.',
      date_after_or_equal_days:
        'Enter a date from today to {{numOfOffsetDays}} {{stringOfOffsetDays}} after.',
      date_before_yesterday: "Enter yesterday's date.",
      date_before_days:
        'Enter a date from yesterday to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      date_before_or_equal_days:
        'Enter a date from today to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      date_between_days:
        'Enter a date between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after today.',

      time_only_now: 'Enter the current time.',
      time_no_future: 'Enter a time equal to or before now.',
      time_no_past: 'Enter a time equal to or after the current time.',
      time_after_next_hour: 'Enter a time within the next hour.',
      time_after_hours: 'Enter a time within the next {{hours}} {{stringOfOffsetHours}}.',
      time_after_or_equal_hours:
        'Enter a time from now or up to {{hours}} {{stringOfOffsetHours}} after.',
      time_before_last_hour: 'Enter a time within the last hour.',
      time_before_hours:
        'Enter a time up to {{numOfOffsetHours}} {{stringOfOffsetHours}} before this moment.',
      time_before_or_equal_hours:
        'Enter a time from now or up to {{numOfOffsetHours}} {{stringOfOffsetHours}} ago.',
      time_between_hours:
        'Enter a time from {{numOfLeftHours}} {{stringOfLeftHours}} before to {{numOfRightHours}} {{stringOfRightHours}} after this moment.',

      datetime_only_today: 'Select a date and time for today.',
      datetime_no_future: 'Enter a date and time equal to or before now.',
      datetime_no_past: 'Enter a date and time equal to or after the current time.',
      datetime_after:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} after this moment.',
      datetime_after_days_only:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} after this moment.',
      datetime_after_or_equal:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} after.',
      datetime_after_or_equal_days_only:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} after.',
      datetime_before:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} ago.',
      datetime_before_days_only:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      datetime_before_or_equal:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} before.',
      datetime_before_or_equal_days_only:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} before.',
      datetime_between:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_between_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',
      datetime_between_left_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_between_right_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',
      datetime: {
        afterMessage:
          'The date and time must be after the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} later.',
        afterOrEqualMessage:
          'The date and time must be equal to or after the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} later.',
        beforeMessage:
          'The date and time must be before the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} ago.',
        beforeOrEqualMessage:
          'The date and time must be the day the form is answered or up to {days} {daysUnit} and {hours} {hoursUnit} ago.',
        betweenMessage:
          'The date and time must be within the range from {daysBefore} {daysBeforeUnit} and {hoursBefore} {hoursBeforeUnit} before to {daysAfter} {daysAfterUnit} and {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The date and time must be outside the range from {daysBefore} {daysBeforeUnit} and {hoursBefore} {hoursBeforeUnit} before to {daysAfter} {daysAfterUnit} and {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
      },
      date: {
        afterMessage:
          'The date must be after the day the form is answered, with a maximum of {days} {daysUnit} later.',
        afterOrEqualMessage:
          'The date must be the day the form is answered or up to {days} {daysUnit} later.',
        beforeMessage:
          'The date must be before the day the form is answered, with a maximum of {days} {daysUnit} ago.',
        beforeOrEqualMessage:
          'The date must be the day the form is answered or up to {days} {daysUnit} ago.',
        betweenMessage:
          'The date must be within the range from {daysBefore} {daysBeforeUnit} before to {daysAfter} {daysAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The date must be outside the range from {daysBefore} {daysBeforeUnit} before to {daysAfter} {daysAfterUnit} after the moment the form is answered.',
      },
      time: {
        afterMessage:
          'The time must be after the moment the form is answered, with a maximum of {hours} {hoursUnit} later.',
        afterOrEqualMessage:
          'The time must be at the moment the form is answered or up to {hours} {hoursUnit} later.',
        beforeMessage:
          'The time must be at most {hours} {hoursUnit} before the moment the form is answered.',
        beforeOrEqualMessage:
          'The time must be at the moment the form is answered or up to {hours} {hoursUnit} ago.',
        betweenMessage:
          'The time must be within the range from {hoursBefore} {hoursBeforeUnit} before to {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The time must be outside the range from {hoursBefore} {hoursBeforeUnit} before to {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
      },
    },
    number: 'Number',
    noValidation: 'No validation',
    validNumberWarning: 'Enter a valid number',
    validSetWarning: 'Enter a valid range',
    separator: 'Separator',
    separatorWarning: 'Enter a valid separator',
    relatedList: 'Related list',
    updateAssetData: 'Update data',
    selectData: 'Select the asset data to update',
    selectMeterQuestion: 'Select the question that will capture the data',
    meterConfigBannerMeter:
      'The system will automatically update the asset information with the data registered in this form.',
    addMeterQuestion: 'Add another question that captures data',
    addMeterConfiguration: 'Add meter',
    createNumberQuestion: 'Create a new number question',
    createSelectMetadataQuestion: 'Create a new single option data question',
    header: 'Header',
    headerPlaceholder: 'Country | City | Street',
    headerWarning: 'You must enter a header that contains the separator',
    headerDefault: 'List without header',
    deprecatedWarning: 'This type of question is no longer supported',
    combineAlert1: 'Questions can only be dragged into group of repeatable questions.',
    combineAlert2:
      'A group of repeatable questions cannot contain another group of repeatable questions.',
    combineAlertTitle: 'Error',
    emptySubform: 'Empty',
    emptySubformAlert:
      'Group of repeatable questions cannot be left empty, a question has been created automatically.',
    emptySubformAlertTitle: 'Warning',
    emptySubformTooltip: 'Remove all questions from group of repeatable questions',
    removeSubformQuestionTooltip: 'Remove question from group of repeatable questions',
    subformRemoveConfirm:
      'This question will be removed from this group of repeatable questions and added to the main form.',
    subformEmptyConfirm:
      'All questions will be removed from the group of repeatable questions and added to the main form.',
    confirm: 'Confirm',
    subformLimit: 'Limit repetitions',
    subformWarning: 'For more than 5 repetitions, upgrade your plan in configuration > billing',
    answer: 'Answer',
    includeComments: 'Comment',
    commentsFormLabel: 'Select the answers which require a comment.',
    textCommentBtnTooltip: 'Required Text',
    imageCommentBtnTooltip: 'Required Image',
    findingCommentBtnTooltip: 'Required Issue',
    imageCommentBtnTooltipDisabled: "You can't add over a max of 500 images in total",
    share: 'Share',
    mobileTab: 'Mobile',
    webTab: 'Computer',
    max: 'Máximum',
    min: 'Mínimum',
    asCount: 'Counter',
    dataListSearchModalTitle: 'My lists',
    editLists: 'Edit lists',
    editLocations: 'Edit locations',
    editAssets: 'Edit assets',
    use: 'Use',
    usedInThisForm: 'Used in this form',
    otherLists: 'Other lists',
    customLists: 'Custom',
    locations: 'Locations',
    selectAll: 'Select all',
    customLocations: 'Custom locations',
    searchInListPlaceholder: 'Search in this list...',
    locationAccessAlert:
      'Some users might not see this question if they do not have access to the selected locations',
    customListsDescription: 'Store any type of data you need to query (includes old locations)',
    locationsDescription: 'Centralize and control information about your physical spaces',
    assetsDescription: 'Manage assets with all their information, location and meters',
    selectDataListInstruction: 'Select the data list that best fits your question',
    multi_photo: 'Multiple photos',
    mobileOnlyAlert:
      'Available only in mobile forms. If this question is required, you can still answer the webform but this question will not appear.',
    oldLocationsListWarning:
      "You're using an old location list. Create a new one to take advantage of the benefits.",
    availableAppWeb: 'Available on web and mobile app',
    imageDisabledByLimit:
      'The option to upload images has been disabled. It is not possible to upload more than 500 images in total',
    formBuilderBlockedAlertPart1:
      'You do not have permission to edit this form. If you want to create or edit forms ',
    formBuilderBlockedAlertPart2: 'upgrade your plan',
    formBuilderBlockedAlertPart3: ' now and unlock unlimited productivity',
    formNameExists: 'This form name already exists',
    saveError: 'There was an error saving the form',
    formLockedForEditing: 'Form is locked for editing.',
    validationFixedRange: 'Fixed Range',
    validationRelativeRange: 'Relative Range(available only in app)',
    validationComparisonType: 'Comparison Type',
    validationSelectComparisonType: 'Select comparison type',
    minimumValue: 'Minimum Value',
    maximumValue: 'Maximum Value',
    offset: 'Offset',
    pickQuestion: 'Pick a Question',
    noQuestionsAvailable: 'No questions available for comparison',
    validationType: 'Validation Type',
    theNumberMustBe: 'The number must be',
    theNumberMustNotBe: 'The number must not be',
    than: 'than',
    plus: 'plus',
    minus: 'minus',
    hoursLabel: 'hrs',
    hourLabel: 'hr',
    andMinutesLabel: 'and',
    minuteLabel: 'minute',
    minutesLabel: 'minutes',
    activityStartTime: 'Select the start time of the working hours',
    activityDuration: 'Select the duration of the working hours',
    activityInterval: 'Select the time interval',
    every: 'Every',
    chooseSelectMetadataQuestion: 'Select a {select_metadata} question',
    chooseNumberQuestion: 'Select a {number} question',
    tabs: {
      builder: 'Form Builder',
      integrations: 'Integrations',
      signature: 'Signature',
      email: 'Email',
      pdf: 'PDF',
    },
    dynamicSignatureModificationAlert: {
      title: 'Some signatures might stop working',
      description:
        'The changes you are making could affect the electronic signatures associated with these questions.\nIf you continue, those signatures may be deactivated.',
      continue: 'Continue',
      cancel: 'Cancel',
    },
  },
  help: {
    multi_option: 'Select an option from a list of items',
    select_metadata: 'Select an option from a dynamic data list',
    select_option_metadata: 'Select an option for each item on the list',
    select_option_metadata_comments: 'Select fixed alternatives for each item of a custom list',
    track_code: 'Provide the option to change or select the tracking code of each form',
    static_text: 'Allows adding fixed text as a form instruction',
    select_check_metadata: 'Select multiple items in a dynamic data list',
    select_number_metadata: 'Select a number for each item in the dynamic data list',
    select_text_metadata: 'Write text for each item in a dynamic data list',
    table: 'Create a group of questions that you can answer more than once',
  },
  types: {
    text: 'Text',
    date: 'Date/Time',
    number: 'Number',
    signature: 'Signature',
    barcode: 'Scanner',
    photo: 'Photo',
    multi_photo: 'Photo',
    multi_option: 'Single Choice',
    select_option_metadata: 'Checklist',
    select_option_metadata_comments: 'Checklist',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Number Data',
    select_text_metadata: 'Text Data',
    static_text: 'Instruction',
    select_metadata: 'Single Option Data',
    table: 'Group of Repeatable Fields',
    attachment: 'Attach File',
    deprecated: 'Deprecated',
    select_activity_period_time: 'Activity Data',
  },
  links: {
    appStore: 'https://itunes.apple.com/us/app/datascope-forms/id1132697668?l=en&ls=1&mt=8',
    playStore: 'https://app.datascope.io/apk',
    appLink: 'https://datascope.page.link/3N7P',
  },
  listManager: {
    dataListSource: 'Data source',
    name: 'Name',
    description: 'Description',
    code: 'Code',
    listItems: 'List Items',
    emptyList: 'This list has no items',
    attribute1: 'Attribute 1',
    attribute2: 'Attribute 2',
    listSubtitle:
      'You can use these lists in question types: Checklist, checkbox, data list number, data list text and data list selection',
    seeAll: 'See all lists',
    seeObj: 'See list items',
    edit: 'Edit list',
    editObj: 'Edit item',
    delete: 'Delete list',
    deleteAction: 'Delete',
    deleteObj: 'Delete item',
    nameInUse: 'Name already in use',
    codeInUse: 'Code already in use',
    nameEmpty: 'Name cannot be empty',
    itemsStillEditing: 'There are items being edited. Confirm or cancel them before saving.',
    deleteObjectWarning: 'Are you sure you want to remove this item from the list?',
    deleteYes: 'Yes, delete',
    confirmDeleteItemsTitle: 'Are you sure you want to delete {count} items?',
    confirmDeleteItemsDesc:
      'They will be deleted, but previously submitted responses will not be affected',
    saveChanges: 'Save',
    cancel: 'Cancel',
    itemsOf: 'Items of:',
    addNewItem: '+ New item',
    page: 'Page ',
    of: ' of ',
    close: 'Close',
    legacy: 'Go to full list manager',
    locations: 'Locations',
    assets: 'Assets',
    customLists: 'Custom lists',
    search: 'Search',
    searchPlaceholder: 'Search by list name, creator, form name',
    import: 'Import',
    importSuccess: 'Lists uploaded successfully. They may take a few seconds to appear',
    importError: 'Error importing list',
    importDescription: 'Upload an XLS, XLSX or CSV file with the list data. Maximum 5MB.',
    export: 'Export',
    newList: 'New list',
    switchToLegacy: 'Switch to previous version',
    switchToNew: 'Switch to new version',
    duplicate: 'Duplicate',
    createdAt: 'Created date',
    type: 'Type',
    items: 'Items',
    creator: 'Creator',
    usedIn: 'Used in',
    usedInDescription: 'Forms that use this list',
    notUsed: 'This list is not being used in any form.',
    noResults: 'No lists found',
    emptyTitle: 'You have no custom lists',
    emptyDescription: 'Create your first list to organize data you can use in your forms.',
    deleteConfirmTitle: 'Delete list',
    deleteSuccess: 'Lists deleted successfully',
    deleteError: 'Error deleting lists',
    duplicateSuccess: 'List duplicated successfully',
    duplicateError: 'Error duplicating list',
    createList: 'Create list',
    editList: 'Edit list',
    details: 'Details',
    listName: 'List name',
    listDescriptionOptional: 'List description (optional)',
    listType: 'List type',
    typeStandard: 'Standard',
    typePrice: 'Price',
    typePercent: 'Percentage',
    typeStandardDesc: "Uses the 'Data list' question",
    typePriceDesc: "Uses the 'Data list number' question",
    itemAttributes: 'Item attributes',
    attributesExportHelper: 'Will be reflected in the PDF export',
    attributeNamePlaceholder: 'Attribute name',
    listItemsSection: 'List items',
    addItemsHelper: 'Add the items this list will contain',
    addItem: 'Add item',
    noItemsYet: 'No items added yet',
    create: 'Create',
    update: 'Update',
    formInfoHelper:
      'In the form response you will only see the items from this list that have been selected',
    actions: 'Actions',
    newItem: 'New item',
    list: 'List',
    searchByNameCode: 'Search by name, code',
    lastResponse: 'Last response',
    results: 'Results',
    itemSelected: 'item selected',
    itemsSelected: 'items selected',
    confirmDeleteItems: 'Are you sure you want to delete {count} items?',
    confirmDeleteItem: 'Are you sure you want to delete "{name}"?',
    listNotFound: 'List not found',
    nameItem: 'Item name',
    textType: 'Text',
    imageType: 'Image',
    nameRequired: 'Name is required',
    codeOptional: 'Code (optional, auto-generated)',
    codeInvalid: 'Only letters, numbers, spaces and underscores',
    codeTooLong: 'Maximum 30 characters',
    auditLogsTitle: 'Import Logs',
    importsTab: 'Lists imported',
    menuImportNow: 'Import now',
    menuViewHistory: 'View history',
    statusStarted: 'Started',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusFailed: 'Error',
    typeSingle: 'Single',
    typeMassive: 'Massive',
    colDate: 'Date',
    colUser: 'User',
    colType: 'Type',
    colList: 'List',
    colFile: 'File',
    colStatus: 'Status',
    colResult: 'Result',
    colDuration: 'Duration',
    noImportsFound: 'No imports recorded',
    listsCount: 'lists',
    itemsDeleted: 'items deleted',
    deleteItemsError: 'Error deleting items',
    noItemsInList: 'No items in this list',
    searchForm: 'Search form',
    noFormsFound: 'No forms found',
    lastResponseSent: 'Last response sent using this list',
    selectedList: 'list selected',
    selectedLists: 'lists selected',
    importTitle: 'Import custom lists',
    importStep1: 'Step 1: Download the file',
    importStep1Desc: 'Download the example Excel. Make sure the fields marked with',
    importStep1Desc2: 'to import your file correctly.',
    importStep2: 'Step 2: Edit the file',
    importStep3: 'Step 3: Upload the file',
    importStep3Desc: 'Drag and drop your file here or select it from your computer.',
    downloadTemplate: 'Download example',
    exportList: 'Export list',
    dragDropExcel: 'Drag and drop your Excel here',
    browseComputer: 'browse',
    fileUploaded: 'Your file has been uploaded',
    fileNotLoaded: 'Your file could not be loaded',
    replaceFile: 'Replace',
    fileRequirements: 'File requirements',
    reqNameColumn: "'Name' column complete.",
    reqUniqueValues: "'Name' and 'Code' columns must have unique values.",
    reqMaxItems: 'Maximum 10,000 items per list.',
    assignListNames: 'Assign a name for each loaded list',
    formatError: 'Incorrect format. The file must be .XLSX or .CSV',
    multiSheetError:
      'The file contains multiple sheets. To import multiple lists, use the importer from the main lists page.',
    importing: 'Importing...',
    invalidListId: 'Invalid list ID',
    duplicateCodeError: "Code '{key}' is repeated {count} times",
    duplicateNameError: "Name '{key}' is repeated {count} times",
    templateExampleItem: 'Example item',
    templateExampleDesc: 'Example description',
    inYourComputer: 'on your computer',
    orPrefix: 'or',
    listNameLabel: 'List name',
    sheetLabel: 'Sheet',
    deleteConfirmTitlePlural: 'Delete {count} lists',
    deleteConfirmDescSingle: 'Are you sure you want to delete "{name}"?',
    deleteConfirmDescPlural:
      'Are you sure you want to delete {count} lists? This action cannot be undone.',
    deleting: 'Deleting...',
    form: 'form',
    forms: 'forms',
  },
  locations: {
    planLimits: {
      actionBlocked1: 'This action is blocked by the limits of your current plan.',
      actionBlocked2: 'Upgrade your plan to unlock it.',
    },
    nestableLocationsBanner: {
      title: 'Have you tried the new locations?',
      description:
        'Create hierarchical location lists for a more organized, precise operation with access control. ',
      link: 'Create locations',
    },
    title: 'Locations',
    searchPlaceholder: 'Search',
    header: {
      export: 'Export',
      import: 'Import',
      createPlace: 'Create location',
    },
    export: {
      success:
        'Locations exported successfully. We will email the file to you as soon as it is ready.',
      error:
        'Error exporting locations. Please try again or contact support if the problem persists.',
    },
    import: {
      title: 'Import Locations',
      description: 'Import locations from an Excel file',
      step1Title: 'Step 1: Download the file',
      step1Description: 'Use our Excel template to ensure your locations have the correct format',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Complete the Excel',
      step2Description: 'Add your locations and sublocations following the example format.',
      step3Title: 'Step 3: Upload the file',
      step3Description: 'Drag and drop your file here or select it from your computer.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importError: 'Error importing locations',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      importingDescription: 'Just a moment, we are organizing everything...',
      errorTitle: 'We detected an error.',
      errorMessage: 'Please check that your data has the correct format.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      templateUrlV2:
        'https://s3-us-west-2.amazonaws.com/data-scope/templates/nestable_locations/import_template_en_v2.xlsx',
      instructions: {
        maxSheets: 'The file must contain no more than {maxSheets} sheets for location nesting',
        maxRows: 'The file must contain no more than {maxRows} rows per sheet',
        maxColumns: 'The file must contain no more than {maxColumns} columns per row',
        maxLengthSheetName: 'The sheet name must be no more than {maxLengthSheetName} characters',
        nestingSheetName: 'The nesting sheet name must be the name of the location being nested',
      },
      errors: {
        templateDownloadError: 'Failed to download template',
        invalidFileType: 'Please select a valid Excel file (.xlsx)',
        importError: 'Error importing locations',
        importButton: 'Import',
        cancel: 'Cancel',
        importing: 'Importing...',
        errorTitle: 'We detected an error.',
        errorMessage: 'Please check that your data has the correct format.',
      },
    },
    table: {
      locationName: 'Location name',
      users: 'Users',
      lastActivity: 'Last activity',
      actions: 'Actions',
      resultsCount: 'Results: {start}-{end} of {total}',
      loadMore: 'Load more locations',
      loadMoreError: 'Error loading more locations. Please try again.',
      noResults: 'No results found',
    },
    row: {
      location: 'Location',
      locations: 'Locations',
      selected: 'selected',
      selected_plural: 'selected',
      address: 'Address: ',
      phone: 'Phone: ',
      viewLocation: 'View location',
      users: 'users',
      today: 'Today',
      sublocation: 'Sublocation',
      sublocations: 'Sublocations',
      sublocationTooltip:
        'To create more sublocations you need a higher plan. Upgrade your plan and unlock this and other features',
      viewDetails: 'View details',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View location',
      deselectAll: 'Deselect all',
      selectAll: 'Select all',
    },
    deleteConfirmation: {
      title: 'Are you sure you want to delete this location?',
      message:
        'The location and all its sublocations will be deleted, but responses, signatures and issues will not be lost.',
      confirmButton: 'Delete',
      cancelButton: 'Cancel',
      success: 'Location deleted successfully',
      error: 'Error deleting location',
    },
    create: {
      title: 'Create location',
      success: 'Location created successfully',
      error: 'Error creating location',
    },
    update: {
      title: 'Update location',
      success: 'Location updated successfully',
      error: 'Error updating location',
    },
    form: {
      displayDescription: 'Location information',
      createDescription: 'Create new location',
      updateDescription: 'New location',
      sections: {
        locationInfo: 'Location Information',
        contactInfo: 'Contact Information',
        ubication: 'Location',
      },
      name: {
        label: 'Name',
        placeholder: 'Enter location name...',
        required: 'Location name is required',
        maxLength: 'Name must be 1000 characters or less',
      },
      code: {
        label: 'Location code',
        placeholder: 'Enter location code...',
        required: 'Location code is required',
        maxLength: 'Code must be 255 characters or less',
        tooltip: 'Optional. If left empty, a unique code will be generated automatically.',
      },
      type: {
        label: 'Location type',
        required: 'Location type is required',
        placeholder: 'Select the type of facility you are creating...',
        options: {
          plant: 'Plant',
          enterprise: 'Enterprise',
          warehouse: 'Warehouse',
          production_line: 'Production Line',
          office: 'Office',
          branch: 'Branch',
          distribution_center: 'Distribution Center',
          other: 'Other',
        },
      },
      origin: {
        label: 'Origin',
        required: 'Location origin is required',
        placeholder: 'Select an existing location to associate...',
        tooltip:
          'By choosing an Origin location, this new location will be placed within another one, forming part of a structure.',
        options: {
          main: 'Main Location',
          subsidiary: 'Subsidiary',
          remote: 'Remote Location',
          temporary: 'Temporary Location',
          partner: 'Partner Location',
        },
      },
      phone: {
        label: 'Phone',
        placeholder: 'Enter phone number...',
        validation: {
          missingCountryCode: 'Number must include country code (e.g. +1)',
          invalidCountryCode: 'Invalid country code',
          invalidFormat: 'Invalid number format',
          invalidLength: 'Invalid number length for this country',
        },
      },
      description: {
        label: 'Description',
        placeholder: 'Enter description...',
        helper: 'Optional details for this location',
        validation: {
          tooLong: 'Description must be 1000 characters or less',
        },
      },
      users: {
        title: 'Users and groups',
        label: 'Users',
        placeholder: 'Enter users information...',
        helper: 'Add information about users assigned to this location',
        showLess: 'Show less',
        showAll: 'Show all',
      },
      emails: {
        label: 'Emails',
        placeholder: 'Enter email addresses...',
        helper: 'Add relevant email addresses for this location',
        inputHint: 'Separate emails with commas or press Enter',
        validation: {
          tooMany: 'Maximum character limit exceeded.',
        },
      },
      coordinates: {
        fetchAddressError: 'Could not retrieve address for the entered coordinates.',
        latitude: {
          label: 'Latitude',
          invalid: 'Latitude must be between -90 and 90.',
          placeholder: 'Enter latitude...',
        },
        longitude: {
          label: 'Longitude',
          invalid: 'Longitude must be between -180 and 180.',
          placeholder: 'Enter longitude...',
        },
      },
      ubication: {
        label: 'Location',
        search: 'Search direction',
        hideMap: 'Hide map',
        showMap: 'Show map',
        placeholder: 'Enter location address...',
        address: 'Address',
        city: 'City',
        region: 'State/Region',
        country: 'Country',
        postalCode: 'Postal Code',
        noLocationsFound: 'No locations found',
        clearData: 'Clear data',
        optionalLabel: 'Optional',
        coordinatesInfoTooltip:
          'You can enter the location by searching for an address or by manually entering latitude and longitude coordinates. Both options are valid.',
      },
      buttons: {
        create: 'Create',
        creating: 'Creating…',
        update: 'Update',
        updating: 'Updating…',
        cancel: 'Cancel',
      },
    },
    emptyState: {
      noLocations: 'No locations found',
      suggestion: 'Try different keywords or check your spelling',
      noLocationsCreated: "You don't have any locations created yet",
      createNewLocation: 'Create a new location',
      migration: {
        title: "Still haven't migrated your locations?",
        description: 'Now you can group your locations by type and view everything in one place.',
        button: 'Migrate my locations',
        close: 'Close',
        imgAlt: 'Representation of a worker with a calendar, a checklist and a PC floating around',
        viewTitle: 'Migrate your locations to the new structure',
        backButton: 'Back to locations',
        whyMigrate: 'Why migrate?',
        reason1Title: 'Gather all recent activity in one place:',
        reason1Description: 'issues, completed forms, signatures, users and associated groups.',
        reason2Title: 'Organize your spaces:',
        reason2Description:
          'adding up to four sublevels per location, to represent how your sites really work.',
        reason3Title: 'Easily decide which users or groups can view and work in each location.',
        reason3Description: 'Users will only see the locations they have been assigned to.',
        stepsTitle: 'Step by step to migrate your locations',
        step1Title: 'Use your current locations as a base',
        step1Description:
          'Download an Excel with the locations you already have in DataScope from here and use it as a base to complete the template and save time.',
        step2Title: 'Download the template',
        step2Description:
          'Use our Excel template to ensure your locations are loaded correctly. In the first sheet you define all locations. If you need hierarchy, create additional sheets to assign sublocations.',
        step3Title: 'Upload the new template to the platform',
        step3Description:
          'When you complete the template, import it here to update your locations with the new structure.',
        faqTitle: 'Frequently asked questions',
        faq1Question: 'What will happen to my previously created locations?',
        faq1Answer:
          'Old locations will continue to work for a while. We will soon begin a gradual closure process to make way for the new location structure.',
        faq2Question: 'Can I still access the old locations?',
        faq2Answer:
          'Yes! You will still be able to access your old locations. They will remain in the same place, they will only change their name to List (Old locations) to differentiate them from the new ones.',
        faq3Question: 'Will my previous forms continue to work?',
        faq3Answer:
          'Yes, forms created with old locations will remain active. In the form builder you will clearly see the old locations differentiated from the new ones.',
        faq3Gif:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/old_locations_en.gif',
        faq4Question: 'How do I assign locations to users?',
        faq4Answer:
          'For new Locations you can assign users individually from the Users section. For bulk assignments, download and upload the user Excel.',
        faq5Question: 'Can I associate a form with multiple locations?',
        faq5Answer:
          'Yes, as long as the locations are on the same hierarchical level. It is not possible to associate a form with locations of different levels.',
        faq6Question: 'Can I use the new locations without having migrated all the previous ones?',
        faq6Answer:
          'Yes, you can migrate partially, as long as the parent locations are already created on the platform. Old locations will continue to work while you complete the migration.',
        faq7Question: 'How do I identify if a location has already been migrated?',
        faq7Answer:
          'In the locations table you will be able to see which sublocations were migrated under each parent location. If any error occurs during migration, we will notify you directly in the process.',
        helpTitle: 'Questions or need help?',
        helpDescription:
          'If you have questions about the process, contact us and we will help you complete the migration.',
        helpButton: 'Request help',
        accessBanner: 'All users will have access to the locations you migrate',
        bannerImageUrl:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/location-migration-banner-en.png',
        modal: {
          title: 'Migrate your locations',
          step1: 'Step 1: Use your existing locations as a base',
          step1Description:
            'If you already have locations created in DataScope, you can download them and use them as a base to complete the template.',
          downloadExistingButton: 'Download your existing locations',
          downloading: 'Downloading...',
          step2: 'Step 2: Download the template',
          step2Description:
            'Use the template format to ensure your locations are loaded correctly.',
          downloadTemplateButton: 'Download the template',
          step3: 'Step 3: Upload your file',
          step3Description:
            'When you have the template ready, upload it here to migrate your locations.',
          cancel: 'Cancel',
          migrateButton: 'Migrate locations',
          migrating: 'Importing...',
          exportSuccess: 'Locations exported successfully',
          exportError: 'Error exporting locations',
          helpAccordion: {
            title: 'How does the template work?',
            videoTitle: 'Step-by-step video',
            videoPlaceholder: '0:00 / 0:10',
            videoUrlV2:
              'https://fast.wistia.net/embed/iframe/9tbrdiuq6r?web_component=true&seo=true',
            fileStructureTitle: 'File structure:',
            fileStructure1: 'Import sheet:',
            fileStructure1Description:
              'Here you import all your locations and sublocations from a single file.',
            fileStructure2: 'Do you want a location to have sublocations?',
            fileStructure2Description:
              'In the Source Location column, enter the location they belong to.',
            fileStructure3: 'Remember to complete the required fields:',
            fileStructure3Description: 'Name and Location Type.',
            fileStructure4: 'Latitude and longitude optional:',
            fileStructure4Description:
              'You can obtain them by searching the address on Google Maps or from',
            fileStructure4Link: 'here',
            fileStructure4Note: 'Use the same location to avoid import errors.',
            technicalLimitsTitle: 'Technical limits for importing:',
            technicalLimit1: 'You can import up to 2,500 locations per file.',
          },
        },
      },
      utility: {
        title: 'Structure and control your operation with locations',
        preConfigTitle: 'For what does locations serve?',
        utilityTitle1: 'Centralize information:',
        utilityDescription1:
          'gather all recent activity, including issues, forms, signatures and users, in one place.',
        utilityTitle2: 'Create place hierarchies:',
        utilityDescription2:
          'add up to four sublocations per place to represent the real structure of your operations.',
        utilityTitle3: 'Assign access easily:',
        utilityDescription3: 'define which users can view and work in each place.',
      },
      reasons: {
        title: 'Why use locations?',
        cardTitle1: 'Flexible structure',
        cardDescription1: 'Adapt the place levels to how your operation works in the real world.',
        cardTitle2: 'Information by levels and types',
        cardDescription2:
          'You can view and manage forms, issues, users and signatures associated with each place.',
        cardTitle3: 'Assign users in each place',
        cardDescription3: 'Assign responsible users to each location.',
      },
      carousel: {
        title: 'Create your first location',
        gifAlt: 'Demostration gif for creating locations',
        step1Title: 'Create location',
        step1Description:
          'Create a location by clicking Create location and define a name, level of place, its type and if applicable, associate it with an existing one.',
        step2Title: 'Complete the data',
        step2Description:
          'Add a phone number, email and a brief description will help you identify it later.',
        step3Title: 'Add the location',
        step3Description:
          'Enter the address and extra details to better identify it on the map. To finish, click Create.',
        nextStep: 'Next',
        previousStep: 'Previous',
      },
      legacy: {
        title: 'Legacy locations (Temporary)',
        description:
          'You can still access them here, although they are not compatible with all new functionalities',
        button: 'View legacy locations',
      },
      createNewTitle: 'Create a new way to organize your operation',
      oldLocationsTitle: 'Your locations are old.',
      oldLocationsDescription: 'Create new ones and take advantage of the benefits',
      createButton: 'Create locations',
      selectorEmptyIllustrationAlt: 'Illustration of the locations empty state',
      noLocationsAvailable: 'No locations available',
      searchPlaceholder: 'Search locations...',
      loadingLocations: 'Loading locations...',
    },
  },
  tasksForms: {
    activateScroll: 'Activate scroll in the app',
    disableScroll: 'Disable scroll in the app',
    scrollActiveSuccess: 'Scroll activated successfully',
    scrollDisabledSuccess: 'Scroll disabled successfully',
    templates: 'Forms Templates',
    useTemplate: 'Use template',
    newVersion: 'Switch to new version',
    oldVersion: 'Switch to old version',
    uniq: 'Question name must be unique',
    title: 'Forms',
    preview: 'Preview',
    export: 'Export',
    export_help: 'You can copy this source code and paste into another form',
    import: 'Import',
    import_confirm: 'Are you sure you want to import this form?',
    importSuccessSync: 'Your form was imported successfully',
    import_success: 'Your form is being imported,  it can take some minutes',
    start_testing: "It's time to test your first form!",
    test_button: 'Test form',
    start_testing_desc:
      'Congrats you have a new form. Now you can start testing it on our mobile App.',
    import_error:
      "Failed to import the form. Please check if it's a valid form or is already imported.",
    clone: 'Duplicate',
    default_title: 'My Form',
    default_question: 'Question',
    drag_questions:
      "You don't have questions in your form yet, drag and drop the questions you want here",
    new: 'New form',
    new_ai: 'Form with AI',
    google_forms: 'Import Google Form',
    are_you_sure: 'Are you sure?',
    status: 'Status',
    active: 'Published',
    inactive: 'Unpublished',
    publish: 'Publish',
    unpublish: 'Unpublish',
    last_info: 'Add HTML at the end of PDF',
    current_logo: 'Current form Logo',
    form_logo: 'Form Logo',
    form_name: 'Name',
    actions: 'Configure',
    answer_form: 'Fill Out',
    edit_app: 'Configure Form',
    edit_share: 'Share',

    delete: 'Delete',
    error_form: 'There was an error',
    success_form: 'Success',
    date: 'Date/Time',
    date_type: 'Date Type',
    date_type_date: 'Date',
    date_type_datetime: 'Datetime',
    date_type_time: 'Time',
    text: 'Text',
    number: 'Number',
    multi_option: 'Single Choice',
    signature: 'Signature',
    barcode: 'Scanner',
    photo: 'Photo',
    select_metadata: 'Single Option Data',
    select_option_metadata: 'Checklist',
    track_code: 'Tracking Code',
    static_text: 'Static Text',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Number Data',
    select_text_metadata: 'Text Data',
    table: 'Group of Repeatable Fields',
    name: 'Question Title',
    description: 'Question Descriptions',
    label: 'Question Section Name',
    choices: 'Choices',
    choice: 'Choice',
    add_choice: 'Add Choice',
    list_values: 'List Values',
    add_list_value: 'Add List Value',
    add_question: 'Add Question',
    delete_choice: 'Delete',
    drop_question: 'Drop repeatable-questions here',
    metadata_type: 'Data List Source',
    create_metadata: 'Create New Data List Source',
    change_metadata: 'Change Data List Source',
    save_form: 'Save Form',
    version: 'version',
    no_name: 'No Name',
    no_questions: 'Must have at least one question',
    no_data: 'No forms available',
    blank_table: 'SubForm must to have',
    sub_questions: 'Sub Questions',
    disable_gallery: 'Disable Gallery',
    required: 'Required',
    back: 'Back',
    location: 'List of Locations',
    help_title: 'Need help creating your form?',
    help_instruction: 'Request form creation',
    help_description:
      '***Please explain the information you want to gather and attach a picture of the form you want to convert mobile',
    example_title_1: 'Build Your Own Digital Forms',
    example_description_1:
      "With the Form Builder you can create perfect forms. It's easy, intuitive, and powerful.",
    success_created: 'Task form was successfully created.',
    hide_logic: 'Skip question based on answer',
    show_price: 'Show price',
    show_avg: 'Show Average',
    show_factor: 'Show Multiplication',
    show_percent: 'Show percent',
    equal: 'Equal',
    not_equal: 'Not Equal',
    if: 'IF',
    is: 'IS',
    to: 'TO',
    go_to: 'GO TO',
    next_question: 'Next Question',
    finish_form: 'Finish Form',
    standard_pdf: 'Standard PDF',
    customized_pdf: 'Customized PDF',
    open_editor: 'Open PDF Editor',
    own_pdf: 'Build your own PDF Layout',
    need_your_pdf: 'Need your own PDF design?',
    pdf_description:
      'The most flexible PDF Builder to create your own documents with the data collected',
    folders: 'Folders',
    manage_folders: 'New folder',
    manage_states: 'Form states',
    view_all_folders: 'View All Folders',
    searchSend: 'Search',
    searchForm: 'Search forms...',
    custom_pdf: {
      step1: 'New template',
      step1_desc:
        'First step is to create your own template using the PDF editor. Is possible to use all the questions of the form. The last answer will be used as example.',
      step2: 'Activate template',
      step2_desc:
        'Next step is to activate the template when is ready. When you activate this, all the new PDFs are going to be generated with this format.',
    },
    help: {
      multi_option: 'Select alternatives into fixed options provided by you',
      select_metadata: 'Select one item of a custom list',
      select_option_metadata: 'Select fixed alternatives for each item of a custom list',
      track_code: 'Provide the option to change or select the tracking code of each form',
      static_text: 'Add static text (Form Instructions)',
      select_check_metadata: 'Check multiple items of a custom list',
      select_number_metadata: 'Select a number for multiple items of a custom list',
      select_text_metadata: 'Select a text for multiple items of a custom list',
      table:
        'Create loops for a specific set of questions that can be answered as many times as needed',
      description:
        'Longer text to show in the App. Does not appear when exporting data. (Optional)',
      title: 'Short title to identify the question. Appears when exporting data.',
    },
    share: {
      title: 'Generate Link Google Forms',
      link: 'Link:',
      edit_link: 'Edit Google Form',
      export: 'Export Google Form',
      sendgrid_template_id: 'd-6603328bc6e14ab284a0bee8ba373651',
      inactive_public_form: 'This form is no longer accessible using this link.',
      success_message: 'We have received your answer correctly',
      make_form_private: 'Remove public access to this form',
      make_form_private_notice:
        'This form is now private. Previously shared public links are now invalid.',
      make_form_public: 'Make this form public',
      make_form_public_notice:
        'This form is now public. You can now share it with people outside your organization!',
      share_via_email: 'Share this form with an email ',
      share_email_tooltip:
        'A public link, accessible to anybody, will be sent to those emails that are not associated with this account. A private use link will be sent to those emails that belong to registered users of this account.',
      share_public_link: 'Share this form with a public link',
      share_public_link_tooltip:
        'Anyone, registered users and non-registered persons alike, will be able to fill out this form if you share the public link with them. Their answers will be registered under the name of a generic user, webforms_user_',
      share: 'Share',
      copy: 'Copy',
      trigger: 'Trigger not installed. Limit of 20 Reached.',
      loading: 'Loading Form...',
      failed: 'Exporting Form Failed.',
      auth: "TIP: 'If you have problems, try logging out of all your Google Accounts (from google.com), and then login with the account you want the form to be exported to.'",
      add_all_permissions: 'Add this form to all users',
      permission_success:
        'Permission added to all users, you need to logout and login again in the App to refresh forms',
    },
    delete_form_confirm: 'Are you sure you want to delete the form?',
    delete_form_warning: 'Once deleted it cannot be recovered',
    delete_form_success: 'Form deleted successfully',
    delete_form_failure: 'Form deletion failed',
    clone_form_success: 'Form duplicated successfully',
    clone_form_failure: 'Form duplication failed',
    publish_form_success: 'Form published successfully',
    publish_form_failure: 'Form publication failed',
    unpublish_form_success: 'Form unpublished successfully',
    unpublish_form_failure: 'Form unpublishing failed',
    rename: 'Rename',
    rename_folder: 'Rename folder',
    folder_name: 'Folder name',
    new_name: 'New name',
    update: 'Update',
    cancel: 'Cancel',
    rename_success: 'Folder renamed successfully',
    rename_failure: 'Folder renaming failed',
    delete_folder_confirm: 'Are you sure you want to delete the folder ',
    delete_warning: 'Once the folder is deleted, all forms inside will be moved to "Forms" table',
    delete_folder_success: 'Folder deleted successfully',
    delete_folder_failure: 'Folder deletion failed',
    move_to_folder: 'Move to folder',
    lockEditing: 'Lock editing',
    unlockEditing: 'Enable editing',
    unlockEditingSuccess: 'Form enabled successfully for editing',
    unlockEditingFailure: 'Failed to enable form for editing',
    editingLocked: 'Editing Locked',
    editingLockedBy: 'Editing locked by:',
    unknownUser: 'Unknown User',
    lockEditingConfirmModal: {
      title: 'Lock form editing',
      message:
        'If you lock it, no one else will be able to edit this form. Only you or support can unlock it.',
      confirmButton: 'Lock',
      cancelButton: 'Cancel',
      successMessage: 'Form locked successfully for editing',
      failureMessage: 'Failed to lock form for editing',
    },
    remove_from_folder: 'Remove from folder',
    move: 'Move',
    warn_empty_folder: 'This action will delete the folder as it would leave it empty.',
    move_form_success: 'Form moved successfully',
    move_forms_success: 'Forms moved successfully',
    move_form_failure: 'Form movement failed',
    move_forms_failure: 'Form movement failed',
    create: 'Create',
    create_form_folder: 'Create form folder',
    create_folder_success: 'Folder created successfully',
    create_folder_failure: 'Folder creation failed',
    how_to_create_folder: 'How do you want to create your folder?',
    next: 'Next',
    form_selection: 'Form selection',
    no_forms_available: 'No forms available at this moment',
    forms: 'Forms',
    form: 'form',
    bulk_action: {
      publish: {
        confirm: 'Are you sure you want to publish',
        info: 'Once published, you can unpublish them again.',
        success: 'Forms published successfully',
        failure: 'Forms publication failed',
      },
      unpublish: {
        confirm: 'Are you sure you want to unpublish',
        info: 'Once unpublished, you can publish them again.',
        success: 'Forms unpublished successfully',
        failure: 'Forms unpublishing failed',
      },
      delete: {
        confirm: 'Are you sure you want to delete',
        info: 'Once deleted, they cannot be recovered.',
        success: 'Forms deleted successfully',
        failure: 'Forms deletion failed',
      },
    },
    formResults: 'Results: ',
    formResultsOf: 'of',
    current_folder: 'Current folder:',
    formLimitReachedTooltip: 'You have reached the form limit. ',
    upgradePlanTooltipLink: 'Upgrade your subscription',
    upgradePlanTooltip: ' to create forms',
    importPermissionError: 'You do not have permission to import templates.',
    projectLimitReachedError:
      'There was an error importing the form. You have reached the maximum number of allowed forms.',
    folder: 'Folder',
    new_form_create: 'Form',
    form_ai: 'Form with AI',
    forms_limit: {
      title: 'Forms limit reached',
      description:
        'You have reached the limit of 3 forms in your current plan. To create more forms, upgrade your plan and access more features:',
      benefit1: 'Unlimited forms',
      benefit2: 'More customization options',
      benefit3: 'Greater storage capacity',
      confirm: 'Unlock more forms now',
      cancel: 'Continue with free version',
      confirm_chat_message: 'Hello, I need to create more forms. How can I upgrade my plan?',
    },
  },
  mobileUsers: {
    users: 'Users',
    new: 'New User',
    import: 'Import',
    import_users: 'Import Users',
    how_import: 'How to Import users?',
    bulk_actions: 'Bulk Actions',
    add_users_to_group: 'Add users to group',
    deactivate_users: 'Deactivate users',
    add: 'Add',
    add_to_group: 'Add to group',
    selectAGroup: 'Select a group',
    identifier_help: 'Needed to sign in in the mobile and web app',
    advanced: 'Advanced Config',
    location_perm: 'Location Permissions',
    forms_perm: 'Forms Permissions',
    activated: 'Activated',
    you: 'You',
    deactivated: 'Deactivated',
    modifications_history: 'History',
    duplicate_user:
      'A deleted User with same email already exists. Please reactivate that user instead',
    old_password_required: 'not valid. For changing admin password confirmation required.',
    group_users: 'User Groups',
    group_new: 'New Group',
    noGroups: 'You have no user groups',
    infoNotice: "Users will only have access to their groups' forms and answers",
    delete_group: 'Delete group',
    cancel: 'Cancel',
    delete: 'Delete',
    rename: 'Rename',
    rename_group: 'Rename group',
    group_name: 'Group Name',
    new_name: 'New Name',
    update: 'Update',
    confirm_group_delete: 'Are you sure you want to delete user group ',
    confirm_group_delete2:
      'Once it has been deleted, users left without a group will go back to their individually assigned permissions.',
    update_groups_success: 'Changes saved successfully',
    update_groups_error: 'An error occurred while saving changes',
    userInfo: 'User Information',
    userGroupsHelp: 'This user belongs to the following groups:',
    manageGroupModalTitle: 'Permissions in',
    searchForm: 'Search form...',
    searchUser: 'Search user...',
    groupUpdateSuccess: 'Group updated successfully',
    permissions_title: 'Permissions',
    forms_title: 'Forms',
    group_name_exists: 'Group name already exists',
    edit_group_permissions: 'Form Permissions',
    edit_groups: 'Assign to a group',
    save: 'Save',
    editGroupsInfo:
      'Users assigned to one or more groups will be granted permissions to access the forms of those groups. Consequently, they will not be able to have individually assigned forms at the same time.',
    modifiedGroup: 'Modified Group',
    modificationAuthor: 'Modified by',
    modificationDate: 'Date',
    modification: 'Modification',
    added: 'Added',
    removed: 'Removed',
    group: 'Group',
    createdGroup: 'Created Group',
    deletedGroup: 'Deleted Group',
    renamedGroup: 'Renamed Group',
    emptyHistory: 'No history available',
    previousName: 'Previous Name',
    assetAssigned: 'Permission assigned to asset',
    assetRemoved: 'Permission removed from asset',
    removeFromGroup: 'Remove from group',
    remove: 'Remove',
    removeUsersConfirm: 'Are you sure you want to remove',
    removeUsersConfirm2: 'user(s) from group',
    onceUsersRemoved:
      'Once users are removed, they will be kept in other groups where they belong or stay as users without group.',
    noUsersInGroup: "You haven't added any users to this group yet",
    searchGroups: 'Search for groups...',
    pendingConfirmationTitle: 'Pending confirmation',
    pendingConfirmationSubtitle: 'Share this link only with this user',
    copy: 'Copy',
    linkCopied: 'Link copied!',
    resendInvitation: 'Resend',
    deleteGroupPendingSignatureError: 'Group has pending signatures',
    invite_user: {
      title: 'Invite Users',
      placeholder: 'example@example.com',
      help: 'If you want to change user permissions, click on configure permissions',
      btn: 'Invite',
      config: 'Configure permissions',
      successSingular: 'Invitation successfully sent',
      successPlural: 'Invitations successfully sent',
      error: 'Failed to invite users, please check that the emails are valid and not used before',
      emailFormatError: 'Wrong email format, please follow example@example.com',
      emails: 'Emails',
    },
    permissions: {
      answers: 'Show Form Answers',
      evaluate: 'Allow to change status of form answers',
      chat: 'Chat',
      tasks: 'Answer Forms',
      assigned: 'View Assigned Forms',
      users: 'Show and Create Users',
      export: 'Export Data',
      metadata: 'Create List of Custom Data',
      modify: 'Modify Form Answers',
      edit_forms: 'Edit Forms',
      evaluate_delete: 'Delete/Recover Form Answers',
      access_to_charts: 'Access to charts',
      admin_account_config: 'Manage account configuration',
      admin_signatures: 'Manage signatures',
      admin_findings: 'Manage issues',
      admin_assets: 'Manage assets',
      admin_places: 'Manage places',
      assign_new_places: 'Assign new places automatically',
    },
    roles: {
      customized: 'Customized',
      administrator: 'Administrator',
      superadmin: 'Account Owner',
      supervisor: 'Supervisor',
      editing_operator: 'Editing-enabled operator',
      operator: 'Operator',
    },
    table: {
      name: 'Name',
      user: 'User',
      role: 'Role',
      lastConnection: 'Last Connection',
      noLastConnection: 'Last Connection not available',
      actions: 'Actions',
      configure: 'Configure',
      edit: 'Edit',
      deactivate: 'Deactivate',
      activate: 'Activate',
      no_data: 'No users available',
      groups: 'Groups',
      viewMore: 'View more',
      noForms: 'This user group has no assigned forms',
      not_confirmed: 'Confirmation pending',
    },
    logs: {
      user: 'Modified User',
      author: 'Modification Author',
      date: 'Date',
      modification: 'Modification',
      activated: 'Activated',
      deactivated: 'Deactivated',
    },
    deactivation: {
      cancel: 'Cancel',
      confirmationTitle: 'Are you sure you want to deactivate this user?',
      confirmationMessage:
        'Data will not be lost. You can activate the user again in the Deactivated section.',
      bulkConfirmationTitle: 'Are you sure you want to deactivate',
      bulkConfirmationMessage:
        'Data will not be lost. You can activate them again in the Deactivated section.',
      success: 'User(s) deactivated successfully',
      error: 'There was an error deactivating the user(s)',
    },
    createUser: {
      information: {
        title: 'Information',
        name: 'Name',
        lastName: 'Last Name',
        email: 'Email',
        example: 'example@example.com',
        password: 'Password',
        passwordHelper: 'Password must be at least 6 characters long',
        phone: 'Telephone',
      },
      group: {
        title: 'Group',
        selectHelper: 'Select an existing group (you can choose more than one)',
        noGroup: 'Without group',
        newGroup: 'New group',
        newGroupHelper: 'Write the name of the group',
        newGroupSuccess: 'New Group created successfully!',
        newGroupError: 'There was an error creating the new group',
        configuration: 'You must configure form permissions for this group',
        formsHelp: 'Forms that this user will have access to:',
        cantEditPermissions:
          'You cannot change your own group permissions. Have someone else do it if you want to change them.',
      },
      forms: {
        title: 'Forms',
        allForms: 'Forms',
        addForm: 'Add form',
        formsHelper: 'The user will only see the forms (and answers) you select. ',
        formsHelperDisabled: 'The user will only see these forms (and answers). ',
        formsGroupHelper:
          'The forms and places to which this user will have access are those belonging to the previously chosen groups.',
        seeMore: 'see more',
        groupsAlert: 'You cannot add forms because you assigned or created a group previously',
        back: 'Back',
        folders: 'Folders',
        close: 'Close',
        formHasPendingSignature:
          "This user has pending signatures. You won't be able to modify the permissions until they are responded to or deleted.",
        massSelectionBlockedByPendingSignature:
          'Mass selection is disabled due to pending signatures',
        foldersBlockedByPendingSignature:
          'Folder selection is disabled due to pending signatures. Open the folder to select forms.',
        cantEditPermissions:
          'You cannot change your own form permissions. Have someone else do it if you want to change them.',
      },
      permissions: {
        title: 'Permissions',
        editingMyself:
          'You cannot change your own permissions. Have someone else do it if you want to change them.',
        basic: {
          title: 'Basic',
          viewFormAnswers: 'View Form Answers',
          chat: 'Chat',
          submitFormAnswers: 'Answer Forms',
          viewAssignedForms: 'View Assigned Forms',
        },
        advanced: {
          title: 'Advanced',
          changeFormStatus: 'Change status of forms',
          createMetadata: 'Create Lists of Custom Data',
          editFormAnswers: 'Edit Form Answers',
          editForms: 'Edit Forms',
          evaluateDelete: 'Delete and recover form responses',
          accessToCharts: 'Access to charts',
          assignNewPlaces: 'Assign new places automatically',
        },
        admin: {
          title: 'Administration',
          viewAndCreateUsers: 'View and Create Users',
          exportData: 'Export Data',
          adminAccountConfig: 'Manage account configuration',
          adminSignatures: 'Manage signatures',
          adminFindings: 'Manage issues',
          adminAssets: 'Manage assets',
          adminPlaces: 'Manage places',
        },
        editFormsTooltip1: 'This user does not have permission to edit forms. ',
        editFormsTooltipLink: 'Upgrade your subscription',
        editFormsTooltip2: ' and unlock full productivity for your team!',
      },
      locations: {
        title: 'Locations (Optional)',
        helper:
          'When this option is activated, the user will only see the forms associated to the selected locations',
        locations: 'locations',
        andOthers: ', and others...',
        cantEditPermissions:
          'You cannot change your own location permissions. Have someone else do it if you want to change them.',
        allLocationsAccessBanner:
          'This user has access to all existing locations. If you want to restrict the locations they can see, you must manually select them from this section.',
        allNewLocationsAccessBadge: 'Access to all new locations',
      },
      signature: {
        name: 'Full Name',
        companyName: 'Company Name',
        pronoun: 'Your',
        userIdNumber: {
          default: 'National ID Number',
          CL: 'RUT',
          PE: 'DNI',
          MX: 'CURP/RFC',
          CO: 'CC',
          AR: 'DNI',
          PY: 'CI',
          ES: 'DNI/NIE',
          BR: 'CPF',
          UY: 'CI',
          BO: 'CI',
          EC: 'Cedula',
          VE: 'National ID Card',
          US: 'SSN/DL/PP/ID',
          CA: 'SIN',
          DO: 'National ID and Electoral Card',
          CR: 'Cedula',
          PA: 'Cedula',
          GT: 'DPI',
          SV: 'DUI',
          HN: 'DNI',
          NI: 'Cedula',
          PR: 'SSN',
          CU: 'CI',
          JM: 'TRN',
          PT: 'NIF',
          FR: 'INSEE',
          DE: 'Personalausweisnummer/Steuer-ID',
          IT: 'Codice Fiscale',
          GB: 'National Insurance Number',
          IE: 'PPS Number',
          NL: 'BSN',
          BE: 'National Number',
          CH: 'AHV Number',
          AT: 'Social Security Number',
          SE: 'Personal Number',
          NO: 'National ID',
          DK: 'CPR Number',
          FI: 'Personal Identity Code',
          IS: 'Kennitala',
          PL: 'PESEL',
          CZ: 'Birth Number',
          SK: 'Birth Number',
          HU: 'Tax Number',
          RO: 'CNP',
          BG: 'EGN',
          GR: 'AMKA/AFM',
          HR: 'OIB',
          SI: 'EMSO',
          RS: 'JMBG',
          BA: 'JMBG',
          ME: 'JMBG',
          MK: 'EMBG',
          MT: 'ID Card',
          CY: 'ID Number',
          LU: 'National ID',
          LT: 'Personal Code',
          LV: 'Personal Code',
          EE: 'Personal Code',
          TR: 'TC Kimlik No',
          IL: 'ID Number',
          SA: 'National ID',
          AE: 'Emirates ID',
          QA: 'QID',
          KW: 'Civil ID',
          BH: 'CPR',
          OM: 'Civil ID',
          JO: 'National ID',
          LB: 'ID Number',
          EG: 'National ID',
          MA: 'CIN',
          TN: 'CIN',
          DZ: 'National ID',
          ZA: 'ID Number',
          NG: 'NIN',
          KE: 'ID Number',
          GH: 'Ghana Card',
          UG: 'National ID',
          TZ: 'NIDA',
          RW: 'National ID',
          BW: 'Omang',
          NA: 'ID Number',
          ZM: 'NRC',
          ZW: 'National ID',
          ET: 'National ID',
          CN: 'National ID',
          IN: 'Aadhaar',
          PK: 'CNIC',
          BD: 'NID',
          JP: 'My Number',
          KR: 'RRN',
          SG: 'NRIC/FIN',
          MY: 'MyKad',
          ID: 'KTP',
          PH: 'UMID',
          TH: 'National ID',
          VN: 'CCCD',
          HK: 'HKID',
          TW: 'National ID',
          LK: 'NIC',
          NP: 'National ID',
          AU: 'TFN/Medicare',
          NZ: 'IRD Number',
          RU: 'SNILS',
          UA: 'Tax Number',
          BY: 'National ID',
          KZ: 'IIN',
          UZ: 'PINFL',
          GE: 'Personal Number',
          AM: 'Social Card',
          AZ: 'FIN',
        },
        country: 'Country',
        selectCountry: 'Select a country',
        noResults: 'No countries found',
        userEmail: 'Personal Email',
        legalRepresentative: 'Legal Representative',
        companyIdNumber: {
          default: 'Tax ID Number',
          CL: 'RUT',
          PE: 'RUC',
          MX: 'RFC',
          CO: 'NIT',
          AR: 'CUIT',
          PY: 'RUC',
          ES: 'NIF',
          BR: 'CNPJ',
          UY: 'RUT',
          BO: 'NIT',
          EC: 'RUC',
          VE: 'RIF',
          US: 'EIN',
          CA: 'BN',
          DO: 'RNC',
          CR: 'Cédula Jurídica',
          PA: 'RUC',
          GT: 'NIT',
          SV: 'NIT',
          HN: 'RTN',
          NI: 'RUC',
          PR: 'EIN',
          CU: 'NIT',
          JM: 'TRN',
          PT: 'NIPC',
          FR: 'SIREN',
          DE: 'Tax Number',
          IT: 'Partita IVA',
          GB: 'Number',
          IE: 'Number',
          NL: 'KvK',
          BE: 'BCE/KBO',
          CH: 'UID',
          AT: 'Tax Number',
          SE: 'Org Number',
          NO: 'Org Number',
          DK: 'CVR',
          FI: 'Y-tunnus',
          IS: 'Kennitala',
          PL: 'NIP/REGON',
          CZ: 'IČO',
          SK: 'IČO',
          HU: 'Tax Number',
          RO: 'CUI',
          BG: 'UIC',
          GR: 'Tax Number',
          HR: 'OIB',
          SI: 'Tax Number',
          RS: 'PIB',
          BA: 'Tax Number',
          ME: 'Tax Number',
          MK: 'Tax Number',
          MT: 'VAT Number',
          CY: 'Tax Number',
          LU: 'Tax Number',
          LT: 'Code',
          LV: 'Reg Number',
          EE: 'Reg Code',
          TR: 'Tax Number',
          IL: 'Number',
          SA: 'CR Number',
          AE: 'Trade License',
          QA: 'CR Number',
          KW: 'CR Number',
          BH: 'CR Number',
          OM: 'CR Number',
          JO: 'Tax Number',
          LB: 'Tax Number',
          EG: 'Tax Number',
          MA: 'RC',
          TN: 'Tax Number',
          DZ: 'NIS',
          ZA: 'Registration Number',
          NG: 'RC Number',
          KE: 'PIN',
          GH: 'TIN',
          UG: 'TIN',
          TZ: 'TIN',
          RW: 'TIN',
          BW: 'Tax Number',
          NA: 'Tax Number',
          ZM: 'TPIN',
          ZW: 'Tax Number',
          ET: 'TIN',
          CN: 'USCI',
          IN: 'CIN/GSTIN',
          PK: 'NTN',
          BD: 'TIN',
          JP: 'Number',
          KR: 'Registration Number',
          SG: 'UEN',
          MY: 'SSM Number',
          ID: 'NPWP',
          PH: 'TIN',
          TH: 'Tax ID',
          VN: 'Tax Code',
          HK: 'BR Number',
          TW: 'UBN',
          LK: 'BRC Number',
          NP: 'PAN',
          AU: 'ABN/ACN',
          NZ: 'NZBN',
          RU: 'INN/OGRN',
          UA: 'EDRPOU',
          BY: 'UNP',
          KZ: 'BIN',
          UZ: 'Tax Number',
          GE: 'Tax Number',
          AM: 'Tax Number',
          AZ: 'Tax Number',
        },
        companyLabel: 'Company',
        address: 'Address',
        companyEmailError: "You must use an email that's different from the user's email",
        userIdNumberError: 'invalid',
        userIdNumberSuccess: 'has been verified',
        companyIdNumberError: 'invalid',
        companyIdNumberSuccess: 'has been verified',
      },
      cancel: 'Cancel',
      save: 'Save',
      success: 'Mobile user created successfully!',
      error: 'There was an error creating the new mobile user',
    },
    editUser: {
      information: {
        oldPassword: 'Current Password',
        newPassword: 'New Password',
        passwordChange: 'Change password',
        error: 'There was an error updating the user',
        success: 'Mobile user updated successfully!',
      },
    },
    createGroup: {
      button: 'Create group',
      title: 'Create user group',
      chooseHeader: 'How do you want to create the group?',
      name: 'Group name',
      nameHelper: 'Group name',
      userSelection: 'User selection',
      formSelection: 'Form selection',
      importExcelNote: "*You'll need to assign permissions to forms later",
      warning:
        'Users assigned to a group will access the forms of that group and cannot have individually assigned forms at the same time.',
      empty_state: {
        title: 'Segment forms and tasks by user groups',
        subtitle: 'What is a user group?',
        descriptionPart1:
          'User groups allow you to control what information each person can see. When you assign forms to a group, only their members will have access to those forms and their data.',
        descriptionPart2:
          'This ensures that each user only sees what they should according to their role or area, improving control and security of information.',
        block1: {
          title: 'Why use user groups?',
          card1: {
            title: 'Information control and security',
            description:
              'Group users with special permissions and access. Protect sensitive data and ensure confidentiality.',
          },
          card2: {
            title: 'Simplified team management',
            description:
              'Assign permissions by group to manage teams easily. Save time and avoid manual errors.',
          },
          card3: {
            title: 'Optimize team experience',
            description:
              'Show only relevant information for each user. Streamline processes and improve fieldwork.',
          },
        },
        block2: {
          title: 'Create your first user group',
          demo1: {
            title: 'Via DataScope',
            description:
              'Create a user group directly from DataScope by manually selecting users and associated forms.',
          },
          demo2: {
            title: 'Importing your user list',
            description:
              'Download the Excel template from DataScope, fill in your user data, and upload it back to the platform. Important! Do not modify the headers and respect the format to ensure a successful upload.',
          },
          next: 'Next',
          previous: 'Previous',
        },
        block3: {
          title: 'Group, assign, and simplify',
          description:
            'Now that you know how groups work, create one, start using them in your daily tasks, and begin optimizing your operations.',
        },
      },
    },
    setProfile: {
      completeProfile: 'Complete your profile',
      completeProfileDescription: 'Please complete the following information to enter DataScope',
      newPassword: 'New password',
      name: 'Name',
      lastName: 'Last name',
      phone: 'Phone',
      save: 'Finish',
      updateSuccess: 'Profile updated successfully',
      updateError: 'There was an error updating the profile',
      identifier: 'Identifier',
    },
    importUsers: {
      invalidFileType: 'Invalid file type. Please upload an .xlsx file',
      dragDropHere: 'Drag and drop your Excel file here',
      orBrowse: 'or browse',
      downloadSuccess: 'Template downloaded successfully!',
      downloadError: 'Failed to download template',
      uploadSuccess: 'File uploaded successfully!',
      uploadError: 'Failed to upload file',
      importTitle: 'Import Users',
      upload: 'Import',
      downloadStep: 'Step 1: Download the template file',
      downloadStepHelper: 'Download the template file to fill in the user information',
      editStep: 'Step 2: Edit the file',
      editStepHelper: 'Edit the Excel file and fill in the required fields *.',
      uploadStep: 'Step 3: Upload the file',
      uploadStepHelper: 'Upload the edited file to import users.',
      downloadTemplate: 'Download Example',
      afterUploadInfo:
        'After uploading, users will be processed and you will be notified if there are errors.',
      replace: 'Replace',
      fileLoadedMessage: 'Your file has been uploaded',
    },
  },
  login: {
    greeting: 'Hi again!',
    loginHelper: 'To continue, enter your credentials',
    googleLogin: 'Login with Google',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    login: 'Log in',
    noAccount: "Don't have an account?",
    signUp: 'Register here',
    success: 'Login successful',
    error: 'Login failed',
    wrongCredentials: 'Email or password is incorrect. Check your credentials and try again.',
    logoutError: 'Logout failed',
    recaptchaError: 'Captcha verification failed. Please try again.',
    mfaTitle: 'Two-Factor Authentication',
    mfaSubtitle: 'Enter the 6-digit code from your authenticator app',
    mfaCodeLabel: 'Verification Code',
    verify: 'Verify',
    backToLogin: '← Back to login',
    invalidMfaCode: 'Please enter a valid 6-digit code',
    invalidMfaCodeError: 'Invalid verification code. Please try again.',
    mfaStatusError: 'Error checking 2FA status',
    mfaEnableError: 'Error enabling MFA',
    mfaEnabledSuccess: 'MFA enabled successfully',
    mfaVerifyError: 'Error verifying MFA',
    mfaDisableError: 'Error disabling MFA',
    mfaDisabledSuccess: 'MFA disabled successfully',
    mfaSetupTitle: 'Set up your authenticator app',
    mfaScanQr: 'Scan the QR code with your authenticator app.',
    mfaSecretCode: 'Secret code',
    mfaCancel: 'Cancel',
    mfaClose: 'Close',
    mfaSetup: 'Set up MFA',
    mfaDisable: 'Disable MFA',
    ssoLogin: 'SSO Login',
    ssoSubtitle: 'To continue, enter your company email adress',
    ssoCompanyEmail: 'Company Email',
    ssoCompanyEmailPlaceholder: 'Enter your company email address',
    ssoValidating: 'Validating your email...',
    ssoContinue: 'Continue with SSO',
    ssoHelpText: "We'll redirect you to your company's login page",
    ssoBackToLogin: 'Login with password',
    ssoSignInWithSSO: 'Sign in with SSO',
    ssoCompletingAuth: 'Completing authentication...',
    ssoVerifyingCredentials: 'Verifying your credentials',
    ssoAuthSuccessful: 'Authentication Successful!',
    ssoAuthFailed: 'Authentication failed',
    ssoRedirecting: 'Redirecting you back...',
    ssoError: 'SSO authentication failed. Please try again.',
    ssoTooManyAttempts: 'Too many login attempts. Please try again later.',
    ssoInvalidIdentifier: 'Invalid email address. Please check your company email and try again.',
    ssoNoAccountsFound: 'No SSO-enabled accounts found for this email domain.',
    ssoFailedValidation: 'Email validation failed. Please check your company email and try again.',
    ssoFailedStatus: 'Failed to check SSO status. Please try again.',
    secureLoginMessage: 'You are logging in with your corporate account through a secure login.',
    ssoFailedInitiate: 'Failed to initiate SSO login. Please try again.',
    checkingAuthentication: 'Checking authentication...',
    ssoConnecting: 'Connecting with your corporate account...',
    ssoRedirectingToSSO:
      "We are redirecting you to your company's secure login page to complete access.",
    ssoNoSSO: 'This account does not use Single Sign-On (SSO).',
    ssoContinueWith: 'Continue with',
    ssoAuthenticationFailed: 'Authentication failed. Please try again.',
    ssoAuthenticationError: 'An error occurred during authentication.',
    ssoAuthenticationProcessing: 'Processing authentication...',
    ssoAuthenticationFailedRedirect: 'Authentication failed. Redirecting to login...',
    ssoAuthenticationCompleting: 'Completting authentication...',
    ssoFailedProviderLogin: 'Error initiating login with selected provider.',
    ssoSelectProvider: 'Select an option to continue',
    magicLinkCta: 'Email me a magic link',
    magicLinkRequestError: 'We could not send the link. Please try again.',
    magicLinkSentHeading: 'Check your email to sign in',
    magicLinkSentBody: 'We sent a sign-in link to',
    magicLinkSentNoEmail: "Didn't receive the email? Check your spam folder. You can also",
    magicLinkResend: 'resend the link',
    magicLinkResendCooldown: 'Wait %{seconds}s to resend',
    magicLinkBack: '← Back to sign in',
    continueCta: 'Continue',
    usePasswordCta: 'Use password instead',
    passwordCta: 'Sign in with password',
    changeEmailCta: '← Change email',
    taglinePasswordless: 'Sign in with a magic link — no password needed.',
  },
  forgotPassword: {
    title: 'Reset your password',
    description: 'Enter your email and we will send you a link to reset your password.',
    email: 'Email',
    continue: 'Continue',
    backToLogin: 'Back to login',
    success:
      'If the email entered is valid, we will send you a message with the steps. If you do not see it, check your spam folder.',
    error: 'An error occurred while sending the email, please try again.',
    recaptchaError: 'Captcha verification failed. Please try again.',
  },
  resetPassword: {
    title: 'Change password',
    description: 'Enter your new password and confirm it.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    continue: 'Reset password',
    passwordsMatchError: 'Passwords do not match',
    success: 'Password updated successfully',
    error: 'An error occurred while updating the password, please try again.',
  },
  signUp: {
    title: 'Create your account',
    subtitle: 'No credit card required, cancel anytime',
    templatePreviewTitle: "You're one step away from using:",
    name: 'Name',
    lastName: 'Last name',
    email: 'Email',
    password: 'Password',
    companyName: 'Company',
    role: 'Role',
    phoneNumber: 'Country and phone number',
    alreadyHaveAccount: 'Already have an account?',
    signUp: 'Create account',
    error: 'An error occurred while creating the account, please try again.',
    privacyPolicyText: 'By clicking you agree to our',
    privacyPolicyLink: 'Privacy Policy',
    emailError: 'Invalid email',
    phoneNumberError: 'Invalid phone number',
    passwordError: 'Password must be at least 6 characters long',
  },
  templates: {
    total_templates: 'Total Form Templates: ',
    see_all: 'See all',
    showing_results: 'Showing results for',
    categories: 'Categories',
    in: 'in',
    useTemplate: 'Use template',
    loginToAnswerTemplate: 'You can answer this template after logging into your account',
    backToDataScope: 'Back to DataScope',
    noResults: 'We have not found what you were looking for, but we would love to find a solution!',
    contactSupport: 'Tell us about the form you need via chat',
    next: 'Next',
    back: 'Back',
    useCase: 'Can be used for:',
    createdBy: 'Created by',
    anonymousUser: 'Anonymous user',
    preview: 'Preview',
    editableTemplate: 'This template can be modified after importing it.',
    allTemplates: 'All Templates',
    noDescription: 'No description',
    bannerSlogan: 'Collect all your data from any mobile device',
    templateView: 'Template View',
    seeLess: 'See less',
    seeMore: 'See more',
    importError: {
      formLimitReached: 'Form limit reached. Please upgrade your plan to import more forms.',
      alreadyImported: 'This form has already been imported.',
      validationError: 'Validation error occurred while importing the template.',
      loginRequired: 'You must be logged in to import templates.',
      genericError: 'An error occurred while importing the template. Please try again.',
      invalidUrl: 'Invalid template URL. Please check the link and try again.',
    },
  },
  navbar: {
    features: 'Features',
    solutions: 'Solutions',
    work_orders: 'Work Orders',
    safety: 'Safety',
    inspections: 'Inspections',
    quality: 'Quality',
    resources: 'Resources',
    blog: 'Blog',
    ds_academy: 'DataScope Academy',
    digitize: 'Digitize your form',
    roi: 'ROI Calculator',
    pricing: 'Pricing',
    sales: 'Talk to Sales',
    wapp: '',
    call: '',
    demo: '',
    sign_in: 'Sign In',
    sign_up: 'Sign up Free',
    log_out: 'Log Out',
    paths: {
      work_orders: 'work-orders',
      safety: 'safety',
      inspections: 'inspections',
      quality: 'quality',
      blog: 'blog',
      ds_academy: 'digitalize-your-operations-with-datascope-2',
      digitize: 'upload-form',
      roi: 'roi',
    },
  },
  uiComponents: {
    search: 'Search',
    showingResultsFor: 'Showing search results for',
    found: 'found',
    cancel: 'Cancel',
    selected: 'selected',
    confirm: 'Confirm',
    close: 'Close',
    chooseMethodDialog: {
      fromDatascope: 'From DataScope',
      importExcel: 'Import Excel',
    },
    signature: {
      title: 'Electronic Signature',
      alert:
        'Complete the following fields to create your signature. Name and last name in the information area are required to create your signature.',
      accountAlert: 'Remember to click "Save Signature".',
      saveSignature: 'Save Signature',
      completeSignatureWarning: 'You must fill out all the required fields to save your signature',
      signatureRequiredFieldError: 'This field is required to create the electronic signature',
      updateSuccess: 'Signature saved successfully!',
      updateError: 'There was an error saving the signature',
      invalidEmailError: 'Invalid email',
      emailExistsError: 'Email address is already in use',
      validatingRut: 'Validating RUT...',
      emailErrors: {
        REGEX_INVALID: 'Invalid email',
        IN_USE: 'Email address is already in use',
      },
    },
  },
  formEmailBuilder: {
    message: 'Message',
    subject: 'Subject',
    senderName: "Sender's Name",
    addFooter: 'Add Signature',
    footerTitle: 'Signature',
    notification: 'Notification',
    autoNotify: 'Notify fixed emails',
    save: 'Save',
    cancel: 'Cancel',
    linkName: 'PDF Form Download Link',
    linkNamePlaceholder: 'Enter the name you want the link to have',
    linkNameHelp:
      'The name you configure will be the one in the download link that will arrive in the email.',
    saveSuccess: 'Configurations saved successfully',
    saveError: 'There was an error saving the configurations',
    autoGeneratePdf: 'Generate PDF Automatically',
  },
  accountConfig: {
    information: {
      title: 'Account Configuration',
      name: 'Company Name',
      description: 'Company Description',
      email: 'Company Email',
      phone: 'Company Phone',
      address: 'Company Address',
      timezone: 'Timezone',
      locale: 'Language',
      dateFormat: 'Date format',
      dateFormatDescription: 'Select the date format that will be used throughout the application',
      dateFormatDdMm: 'dd/mm/YYYY',
      dateFormatDdMmExample: 'Example: 25/12/2024',
      dateFormatMmDd: 'mm/dd/YYYY',
      dateFormatMmDdExample: 'Example: 12/25/2024',
      dateFormatPreview: 'Preview',
      logo: 'Logo',
      uploadLogo: 'Image',
      logoDescription:
        'Only .PNG or .JPG files. Image size should be 400x400px with a maximum file size of 2MB.',
      logoSizeError: 'The maximum file size allowed is 2MB.',
      saveSuccess: 'Account information updated successfully!',
      saveError: 'There was an error updating the account information',
      pdfAlert: 'The following information will be displayed in the header of the standard PDF.',
      confirmDeleteLogo: 'Are you sure you want to delete the logo?',
      languages: {
        es: 'Español',
        en: 'English',
        pt: 'Português',
      },
      exampleLabel: 'Example:',
      dateLabel: 'Date:',
      timeLabel: 'Time:',
      dateTimeLabel: 'Date and time:',
      dateFormatProfiles: {
        european: 'European',
        english: 'English',
      },
    },
    advancedConfig: {
      title: 'Advanced Configuration',
      activateSupportUser: 'Grant Access to DataScope Support User',
      securityConfig: 'Security Configuration',
      deactivateAccount: 'Disable Account',
      confirmTitle: 'Are you sure you want to disable your account?',
      confirmMessage:
        'This action cannot be undone. All your users and data will also be deactivated.',
    },
    mfaConfig: {
      title: 'Account Security (2FA)',
      subtitle:
        'Protect your account with an additional security level.\nWhen activated, a temporary code will be requested from your authenticator app when logging in.',
      activateMfa: 'Activate two-factor authentication',
      configMode: 'How do you want to configure it for your account users?',
      optional: 'Optional',
      mandatory: 'Mandatory',
      optionalDescription: 'Each user can activate it from their user settings',
      mandatoryDescription: 'All members must configure it to access the platform',
    },
  },
  notifications: {
    title: 'Notifications',
    searchPlaceholder: 'Search by form name...',
    viewFormAnswer: 'View Form Answer',
    viewExcel: 'View Excel',
    viewPdf: 'View PDF',
    tableHeaders: {
      date: 'Date',
      type: 'Type',
      form: 'Form',
      formCode: 'Code',
      user: 'User',
      location: 'Location',
      actions: 'Actions',
    },
    formExport: 'Form Export',
    formAnswer: 'Form Answer',
    filters: {
      title: 'Filters',
      filterByType: 'By type',
      filterByLocation: 'By location',
      filterByUser: 'By user',
      filterByDateRange: 'By date range',
      startDate: 'Start',
      endDate: 'End',
      invalidDate: 'Invalid date',
      invalidDateRange: 'Invalid date range',
      to: 'to',
      eraseAll: 'Erase all',
      apply: 'Apply',
      formAnswers: 'Form Answers',
      formExports: 'Exports',
      clear: 'Clear',
      locationPlaceholder: 'Select a location',
      userPlaceholder: 'Select a user',
      showingResultsFor: 'Showing results for',
    },
    noNotifications: 'No notifications available',
    noResults: 'No results found with the selected filters',
    limitReached:
      'Your account reached the limit. You must activate your account to enable this feature.',
  },
  formSignatureBuilder: {
    signatureTitle: 'E-Signature activation',
    checkboxSignatureActivate: 'Activate electronic signature',
    settingsTitle: 'General settings',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Settings saved successfully',
    saveError: 'An error occurred while saving the settings',
    saveErrorReload:
      'An error occurred while saving the settings. Please reload the page and try again',
    accountSignatureConfigError: "The account's electronic signature configuration is missing",
    generalSettings: 'General Settings',
    mandatorySignature:
      'Mandatory signature (All configured users must respond to the request, either by signing or rejecting it)',
    optionalSignature: 'Optional signature (One of the configured signers must sign)',
    signersSettings: 'Signers Settings',
    authorMustSign: 'The user submitting a response must also sign',
    fixedSignerTitle: 'Fixed signer',
    changeSelection: 'Change selection',
    dynamicSignerTooltip:
      'Dynamic signers are available in the Enterprise plan. Upgrade your plan and access this and more advanced features.',
    upgradePlan: 'Upgrade your plan',
    assignOwner: 'Assign responsible',
    searchPlaceholder: 'Search user or group',
    usersTab: 'Users',
    groupsTab: 'Groups',
    addButton: 'Add',
    cancelButton: 'Cancel',
    externalUsers: 'External users',
    externalUsersDescription: 'External users will be able to view and sign the form',
    selectResponsible: 'Select the request responsible',
    addResponsible: 'Add responsible',
    selectUsersToSign: 'Select the users who must sign the document',
    selectResponsibleTooltip:
      'The selected user will be able to track the status of all requests and edit them, but will not be able to sign. To sign, they must be added to the signers list',
    simultaneousSign: 'Simultaneous Sign',
    sequentialSign: 'Signature sequence',
    simultaneousSignInfo: 'The request will be sent simultaneously to all users',
    sequentialSignInfo: 'The request will be sent in the order you establish',
    simultaneousEmptyState: 'Drag users here to remove them from the sequence',
    sequentialEmptyState: 'Drag users here to create a signature sequence',
    sequentialWarningInfo: 'You must add all users to generate a request - {value} users',
    sequentialSignSuccess: 'Sequence complete',
    automatedSignature: 'Activate automatic signature request',
    locationUser: 'Location emails',
    locationUserTooltip:
      'By selecting "Location Connection", the request will be sent to all emails configured in the first associated place.',
    locationUserViewEmails: 'View emails',
    locationConnection: 'Location Connection',
    locationConnectionTooltip1:
      'If the form includes a question to select a location, a request will be sent to the emails configured there',
    locationConnectionTooltip2:
      'If you assign a task with this form and choose a location, the emails configured there will receive a request when the task is completed',
    optionalSignatureOrderDisabled:
      'This option is not available for optional signature configuration',
    author: "Response's author",
    authorMustSignFirst:
      'This position is fixed within the sequence, but you can move it to Simultaneous Signature',
    deleteSigner: 'Delete user',
    unGroupSigner: 'Ungroup',
    authorUserTooltip:
      'If the response author is already part of the sequence, their original position will be maintained instead of the one assigned for the author',
    addSigners: 'Add Signers',
    addSignersTitle: 'Add Signers',
    selectConfigurationType:
      'Select the type of configuration you need. You can choose one or both.',
    fixedSigner: 'Fixed Signer',
    fixedSignerDescription: 'Internal or external users',
    dynamicSignerCardDescription: 'Based on form responses',
    dynamicSigner: 'Dynamic Signer',
    dynamicSignerDescription: 'Dynamic signers are defined from responses in questions type',
    dynamicSignerDescriptionBold:
      'Data list selection with location lists or custom, or Text with email validation.',
    formQuestionsTitle: 'Questions from this form',
    noDynamicSignatureQuestionsAvailable: 'You have no questions of this type\nat this time',
    selectedSignerSingular: 'selected',
    selectedSignersPlural: 'selected',
  },
  pricing: {
    title: 'Perfect for exploring DataScope features',
    basic: {
      title: 'Basic',
      subtitle: 'Limited users, 60 form answers per month, answer storage for 30 days',
      features: [
        'Unlimited users',
        '60 form responses/month',
        'Data stored for 30 days',
        'Basic form builder',
        'Task assigner',
        'Standard dashboard',
        'Standard photo resolution',
        'Offline functionality',
      ],
      buttonText: 'Actual plan',
    },
    standard: {
      title: 'Standard',
      subtitle: 'Ideal for teams taking their first steps in process digitization',
      features: [
        'Everything included in the Basic Plan +',
        'Unlimited form responses',
        'Data stored forever',
        'Advanced form builder',
        'Custom PDF report generator',
        'Editable user permissions',
        'Data integration with other platforms',
        'In-app user chat',
        'Email/phone/chat support',
      ],
    },
    premium: {
      title: 'Premium',
      subtitle: 'For businesses requiring a comprehensive, real-time view of all their operations',
      features: [
        'Everything included in the Standard Plan +',
        'Advanced dashboards',
        'API support',
        'Configurable photo resolution',
        'Assigned account executive',
        'Workflow support',
      ],
      buttonText: 'Change to premium',
    },
    enterprise: {
      title: 'Enterprise',
      subtitle: 'For large companies seeking a personalized solution and support',
      features: [
        'Everything included in the Premium Plan +',
        'Custom implementation',
        '24/7 preferential support',
      ],
      buttonText: 'Talk to Sales',
    },
    features: 'Features',
    start: 'Start',
    currentPlan: 'Current plan',
    mostPopular: 'Most popular',
    free: 'Free',
    monthlyPerUser: 'monthly per user',
    users: 'users',
    standardBold: 'Standard',
    off: 'off',
    finishesIn: 'Finishes in',
    ofDiscount: 'discount.',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    salesLink: 'https://meetings.hubspot.com/andres-rivera4',
    activePayment: {
      demoSubscription: 'Paid subscription',
      demoSubscriptionDescription: 'Your current plan includes 30 users.',
      demoSubscriptionDescription1: ' user(s).',
      demoSubscriptionDescription2: 'You can invite more by clicking the button below.',
      inviteUsers: 'Invite users',
      demoBannerDescription: 'You have no pending payments!',
      demoBannerDescription2:
        "If you have any questions about your subscription, don't hesitate to contact our team.",
      moreInfo: 'More information',
      viewBillingDetails: 'View billing details',
      changeUsers: 'Change number of users',
      modify: 'Modificar',
      monthlyValue: 'Monthly value',
      annualValue: 'Annual value',
      total: 'Total',
      valuesMayDiffer: '*Values may differ based on your local currency.',
      modifyUsersSuccess: 'Subscription updated successfully!',
      modifyUsersError:
        'Encontramos problemas ao atualizar sua assinatura. Por favor, tente novamente ou entre em contato com nossa equipe de vendas.',
      confirmModifyUsers: 'Are you sure you want to change the number of users?',
      confirmModifyUsersDescription:
        'This action will change the value of your subscription and any difference will be charged immediately.',
      numberOfUsers: 'Number of users',
      paymentDetails: 'Payment details',
    },
  },
  findings: {
    title: 'Issues',
    new: 'New',
    all: 'All',
    createdBy: 'Created by',
    assignees: 'Assignees',
    expires: 'Expires',
    type: 'Type',
    description: 'Description',
    searchPlaceholder: 'Search by name, description, author or ID',
    noResultsWithFilters: 'You have no issues available at the moment',
    createdIn: 'Created in',
    originQuestion: 'Question',
    note: 'Note',
    viewForm: 'View form',
    createYourFirstFinding: 'Create your first issue',
    emptyState: 'Add a Checklist question to a new or existing form to start creating issues',
    goToForms: 'Go to Forms',
    detailEmptyState: 'Select an issue to view the history',
    findingDetail: 'Issue detail',
    idCopied: 'ID copied!',
    findingCodePending: 'Assigning…',
    filtersLinkCopy: {
      tooltip: 'Copy link with filters',
      success: 'Link copied to clipboard',
      error: 'Could not copy link. Check browser permissions.',
    },
    delete: 'Delete',
    deletedSuccessfully: 'Issue deleted successfully',
    tabs: {
      inProgress: 'In Progress',
      closed: 'Closed',
    },
    filters: {
      clearFilters: 'Clear filters',
      filterByPriority: 'Filter by priority',
      filterByStatus: 'Filter by status',
      filterChipAssignee: 'Assignee',
      filterChipCreator: 'Creator',
      filterChipForm: 'Form',
      filterByForms: 'Filter by forms',
      filterByAssets: 'Filter by assets',
      filterByLocations: 'Filter by locations',
      filterByCreators: 'Filter by creator',
      filterByAssignees: 'Filter by assignee',
      noSearchResultsForms: 'No forms were found',
      noSearchResultsAssets: 'No assets were found',
      noSearchResultsLocations: 'No locations were found',
      noSearchResultsCreators: 'No creators were found',
      noSearchResultsAssignees: 'No assignees were found',
      formDeleted: 'Deleted',
      formInactive: 'Inactive',
      dateFilter: {
        title: 'Date',
        popoverTitle: 'Filter by date',
        creationDate: 'Creation date',
        expirationDate: 'Due date',
      },
    },
    options: {
      viewDetails: 'View details',
      addImage: 'Add image',
      sendFormAnswers: {
        menu: 'Send form answers',
        title: 'Form answers',
        button: 'Send to issue',
        cancel: 'Cancel',
        description: 'Select the response you want to send to the issue',
        searchPlaceholder: 'Search form',
        answeredBy: 'Answered by',
        updatedAt: 'Updated at',
        noResults: 'No answers found',
        seeAnswer: 'See answer',
        noAnswers: "You don't have any answers at the moment",
      },
      sendForms: {
        button: 'Send',
        menu: 'Send form',
        sync: 'Syncing',
      },
      share: {
        menu: 'Share link',
        title: 'Share link',
        text: 'Anyone with the link can access the issue',
        activate: 'Enable',
        deactivate: 'Disable',
        loginTitle: 'Welcome to DataScope!',
        loginDescription: 'To continue, please enter your name and email address',
        loginNamePlaceholder: 'Your Name',
        loginEmailPlaceholder: 'Email address',
      },
    },
    createFindingType: 'Create Issue Type',
    createFinding: {
      title: 'Create issue',
      create: 'Create',
      requiredInformation: 'Required Information',
      optionalInformation: 'Optional Information',
      cancel: 'Cancel',
      name: 'Name',
      titleLabel: 'Title',
      titlePlaceholder: 'Describe the problem in a few words',
      descriptionPlaceholder: 'Describe the problem in more detail',
      type: 'Issue type',
      description: 'Description',
      assignees: 'Assignee(s)',
      dueDate: 'Due Date',
      location: 'Location',
      inviteParticipants: 'Invite Participants',
      asset: 'Asset',
      findingSuccess: 'Issue created successfully',
      findingError: 'Error creating issue',
      findingCreated: 'Issue created',
      editInFindings: "Go to the 'Issues' section to make changes.",
      evidence: {
        title: 'Evidence',
        required: 'Required evidence',
        optional: 'Evidence (optional)',
        addPhoto: 'Image',
        uploadError: 'Error uploading image',
        limitReached: 'You can only attach up to {{max}} photos. The rest were ignored.',
        requiredError: 'You must add at least one photo as evidence',
        invalidType: 'Only image files are allowed',
        sizeExceeded: 'File exceeds the maximum allowed size of 10 MB',
      },
      evidenceImageSelected: 'image attached',
      evidenceImagesSelected: 'images attached',
    },
    editFinding: {
      title: 'Edit issue',
      update: 'Update',
      findingSuccess: 'Issue updated successfully',
      findingError: 'Error updating issue',
    },
    closeFinding: {
      title: 'Close issue',
      instruction: 'Complete the following information to close the issue',
      closingNoteLabel: 'In what state did you close the issue?',
      cancel: 'Cancel',
      confirm: 'Close issue',
    },
    status: {
      title: 'Status',
      open: 'Open',
      in_progress: 'In Progress',
      paused: 'Paused',
      closed: 'Closed',
    },
    priority: {
      title: 'Priority',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
    },
    asset: {
      label: 'Asset',
      placeholder: 'Select asset',
      noAsset: 'No asset',
      searchPlaceholder: 'Search',
      clear: 'None',
      clearSelection: 'Deselect asset',
      assetsCount: '{count} assets',
      assetCount: '1 asset',
      selected: '1 selected',
      noAssets: 'No assets found',
      noType: 'No type',
      emptyStateMessage: 'Create assets and take advantage of the benefits',
      goToCreateAssets: 'Create assets',
      noSearchResults: 'No assets found',
    },
    deleteWarningConfirm: 'Are you sure you want to delete this issue?',
    deleteWarningConfirmDescription: 'This action cannot be undone.',
    chat: {
      events: {
        finding_created: 'Issue created',
        finding_closed: 'closed the issue',
        finding_closed_expired: 'closed the issue after the specified deadline',
        status: 'updated the status to',
        priority: 'updated the priority to',
        description: 'updated the issue description to',
        expiration_date: 'updated the due date to',
        name: 'updated the issue name to',
        location: 'updated the location to',
        added_assignees: 'added',
        removed_assignees: 'removed',
        assignees_singular: 'as assignee',
        assignees_plural: 'as assignees',
        added_invitees: 'added',
        removed_invitees: 'removed',
        invitees_singular: 'as invitee',
        invitees_plural: 'as invitees',
        no_expiration_date: 'no expiration date',
        asset: 'updated the issue asset to',
        deleted_asset: 'removed the issue asset',
        evidence_added: 'added {{count}} images to the evidence',
        evidence_added_singular: 'added 1 image to the evidence',
        evidence_removed: 'removed {{count}} images from the evidence',
        evidence_removed_singular: 'removed 1 image from the evidence',
        evidence_modified: 'updated the evidence',
      },
      image: {
        error: 'Error',
        sync: 'Image Syncing',
      },
      evidence: {
        attached: '{{count}} images were attached as evidence of the issue',
        attached_singular: '1 image was attached as evidence of the issue',
        viewerTitle: 'Issue Evidence',
        altMain: 'Evidence {{n}}',
        altThumb: 'Thumbnail {{n}}',
        more: '+{{count}}',
        formPhotosNote: 'Images attached from the question cannot be removed, but you can add more',
      },
      assignedForms: {
        message: 'Please fill out the following form to provide more information',
      },
    },
    export: {
      pdf: {
        title: 'Export PDF',
        tooltip: 'Export PDF',
        info: 'You will export all the information included in the issue. Once exported, the download link will be sent to your email.',
        exportSuccess: 'Issue PDF exported successfully',
        exportError: 'Error exporting issue PDF',
        buttonTitle: 'PDF',
      },
      all: {
        title: 'Export all',
        tooltip: 'Export to Excel',
        info: 'You will export the following variables in Excel format: Name, description, responsible parties, participants, expiration, priority, and location. Once exported, the download link will be sent to your email.',
        exportSuccess: 'Issues data exported successfully',
        exportError: 'Error exporting issues',
        buttonTitle: 'Excel',
      },
      emailInputLabel: 'Email',
      cancel: 'Cancel',
      confirm: 'Export',
    },
    landing: {
      headerTitle: 'Resolve issues quickly, with traceability from start to finish',
      infoTitle1:
        'You will be able to notify the right people to generate an ideal workflow and track issue resolution.',
      actionButton: 'Start free trial',
      infoDemoTime: 'Try Issues free for 30 days',
      infoDisclaimer:
        "Once the free trial ends, you'll still be able to create issues, but you won't be able to access them",
      headerImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-gif-en.gif',
      headerTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-gif-en.gif',
      featuresTitle: 'Everything you need',
      feature1Description: 'Create issues customised by priority',
      feature2Description: 'Keep a record of issue updates',
      feature3Description: 'Perform inspections and link an issue',
      feature1Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature1-en.png',
      feature1TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature1-en.png',
      feature2Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature2-en.png',
      feature2TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature2-en.png',
      feature3Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature3-en.png',
      feature3TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature3-en.png',
      footerImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-notification-en.png',
      footerTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-notification-en.png',
      infoTitle2: 'Make sure not to miss any details while tracking issue evolution',
      featuresMobileImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-features-responsive-en.png',
      featuresMobileTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-features-responsive-en.png',
    },
    demoExpired: {
      title: 'Your free trial has ended!',
      description:
        'To access your data, we invite you to purchase the Issues module. You can access it by clicking on the button',
      actionButton: 'Activate Issues',
    },
    suscriptionCancelled: {
      title: 'Your subscription has expired',
      description:
        'To access your data, we invite you to pay your subscription to the Issues module.',
    },
    adminAlert:
      'You will be able to see all issues, but to receive updates you must assign yourself as assignee or participant.',
    configure: 'Settings',
    config: {
      findingTypes: 'Issue Types',
      createType: 'Create Type',
      editType: 'Edit',
      deleteType: 'Delete',
      deleteTypeDisabled: 'You cannot be left without issue types',
    },
    integrations: {
      title: 'Issues Integration',
      button: 'Integrations',
      gsheetsMenuName: 'Google Sheets',
      gsheetsIntegrationLabel: 'Go to Google Sheets',
      infoTextPart1: 'To ensure proper, private, and secure integration, share your document with',
      infoTextPart2: 'editor',
      infoTextPart3: 'permissions only to',
      inputLabel: 'New Link',
      inputPlaceholder: 'Enter the link of the document to integrate',
      save: 'Save',
      cancel: 'Cancel',
      copyUrl: 'URL copied!',
      created:
        'Integration successfully configured! Please wait a few seconds for the changes to take effect',
      saved: 'Changes saved successfully!',
      savingError: 'Error configuring the integration',
      confirmation: 'Do you want to save the changes made before exiting?',
      webhooks: 'Webhooks',
      webhookUrl: 'Webhook URL',
      infoWebhooksTextPart1:
        'Automate your workflows by allowing DataScope to trigger processes on external platforms.',
      infoWebhooksTextPart2: 'Keep everything in sync effortlessly.',
      import: 'Import',
      populateGSheet: 'Populate GSheet',
      populatingGSheet: 'Populating GSheet...',
      populateGSheetSuccess: 'Google Sheet populated successfully',
      populateGSheetError: 'Error populating the Google Sheet',
    },
    findingTypes: {
      noType: 'Other',
      createTitle: 'Create Issue Type',
      editTitle: 'Edit Issue Type',
      name: 'Name',
      assignees: 'Assignees',
      assigneesCaption: 'If you do not assign a responsible party, you can do so in the app',
      assigneesNoSearchResults: 'No users match your search',
      removeChipAriaLabel: 'Remove',
      clearAllSelectionAriaLabel: 'Clear all',
      location: 'Location',
      locationCaption: 'If you do not assign a location, you can do so in the app',
      assets: 'Assets',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      dueDateAndPriority: 'Due Date and Priority',
      priorityInformationBanner:
        'You can select a priority as default (optional). The creator of the issue will not be able to change it but will see its description.',
      dueDate: 'Due Date',
      dueDateCaption: 'This configuration will start counting from the creation of the issue',
      dueDateValueRequired: 'Please enter a value greater than 0',
      dueDateTypes: {
        days: 'Days',
        hours: 'Hours',
      },
      mandatoryRequirements: 'Mandatory requirements',
      mandatoryRequirementsTooltip: 'Select which elements will be mandatory in the issue',
      mandatoryRequirementsNoMatches: 'No options match your search',
      evidence: 'Evidence',
      evidenceDescription: 'Requires at least one image when creating the issue',
      closureComment: 'Closure comment',
      closureCommentDescription: 'Requires a mandatory comment when closing the issue',
      dueDateRequirement: 'Due date',
      dueDateRequirementDescription:
        'The date will be calculated automatically from the defined days/hours',
      configureDueDate: 'Configure due date',
      priority: 'Priority',
      description: 'Description',
      descriptionPlaceholder: 'Write the description or instruction of the priority',
      additionalInformation: 'Additional Information (Optional)',
      additionalInformationBanner:
        'Assign predefined forms for the participants in this issue to complete',
      evidenceBanner:
        'Define whether issue creators must attach photos as evidence at the time of creation.',
      evidenceOptions: {
        none: 'Not required',
        optional: 'Optional',
        required: 'Required',
      },
      typeCreatedSuccess: 'Issue type created successfully',
      typeCreatedError: 'Error creating issue type',
      typeDeletedSuccess: 'Issue type deleted successfully',
      typeDeletedError: 'Error deleting issue type',
      typeUpdatedSuccess: 'Issue type updated successfully',
      typeUpdatedError: 'Error updating issue type',
      deleteTypeAlertTitle: 'Are you sure you want to delete this type of issue?',
      deleteTypeAlertMessage:
        'If you delete it, you will not be able to recover it, but the information related to it will remain on the platform',
    },
  },
  commonComponents: {
    formSelector: {
      title: 'Forms',
      addForm: 'Add form',
      searchPlaceholder: 'Search form, folder...',
      forms: 'Forms',
      folders: 'Folders',
      save: 'Save',
      cancel: 'Cancel',
      see: 'See',
      more: 'more',
      close: 'Close',
      maxFormsSelected: 'You have reached the maximum number of forms selected',
    },
    confirmActionAlert: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    formDropdownSelector: {
      loading: 'Loading...',
      noFormsFound: 'No forms found',
    },
    dateRangePicker: {
      last7Days: 'Last 7 days',
      last14Days: 'Last 14 days',
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      last90Days: 'Last 90 days',
      thisYear: 'This year',
      today: 'Today',
      thisWeek: 'This week',
      nextWeek: 'Next week',
      next7Days: 'Next 7 days',
      next14Days: 'Next 14 days',
      next30Days: 'Next 30 days',
      next60Days: 'Next 60 days',
      next90Days: 'Next 90 days',
      moreOptions: 'More options',
      pastRanges: 'Past Ranges',
      futureRanges: 'Future Ranges',
    },
    locationSelector: {
      loading: 'Loading...',
      noLocationsFound: 'No locations found',
      placeholder: 'Select a location',
      nestableLocations: 'Locations',
      legacyLocations: 'List of Locations (Old)',
    },
  },
  webHooks: {
    title: 'WebHooks',
    new: {
      title: 'Create new WebHook',
      token: 'Token:',
      expires_in: 'Expires in:',
      expires_at: 'Expires at:',
      form: 'Form',
      select_form: 'Select a form',
      select_all_forms: 'All Forms',
      url: 'Connection URL',
      example_url: 'http://www.yourserver.com/service',
      send_modifications: 'Send modifications',
      oauth_checkbox: 'Authenticate with OAuth2.0',
      save: 'Save',
      back: 'Back to WebHooks',
      configure_oauth: 'Configure OAuth 2.0',
      access_token: 'Access Token URL',
      client_id: 'Client ID',
      client_secret: 'Client Secret Key',
      scope: 'Scope',
      save_oauth: 'Save OAuth Configuration',
      save_oauth_success: 'OAuth Token created successfully',
      save_oauth_error: 'There was an error while creating the OAuth Token',
      token_details: 'Token Details',
      create_webhook: 'Create WebHook',
      create_webhook_success: 'WebHook created successfully',
      create_webhook_error: 'There was an error while creating the WebHook',
    },
    update: {
      update_webhook: 'Update WebHook',
      update_webhook_success: 'WebHook updated successfully',
      update_webhook_error: 'There was an error while updating the WebHook',
    },
  },
  answerView: {
    alreadyRejectedSignature: 'You declined to sign this form',
    rejectConfirmationTitle: 'Are you sure you want to reject this request?',
    rejectConfirmationDescription: "Once rejected, you won't be able to sign this form again.",
    reject: 'Reject',
    rejectSuccess: 'Signature request rejected!',
    rejectError: 'Could not reject the signature',
    rejectAlreadyRejected:
      'The request had already been rejected, so it could not be rejected again.',
    location: 'Location',
    address: 'Address',
    assignee: 'Assignee',
    taskInformation: 'Assigned Task Information',
    description: 'Description',
    tasks: 'Tasks',
    answeredFromMobile: 'Answered from mobile',
    answeredFromWeb: 'Answered from web',
    electronicallySignedBy: 'Electronically signed by:',
    verifySignatureAlert:
      'To sign the form you must verify your signature. You only need to do this once.',
    verifySignature: 'Verify signature',
    configureSignatureAlert:
      'To sign the form you must configure and verify your signature. You only need to do this once.',
    configureSignature: 'Configure electronic signature',
    lackOfPermissions:
      'You do not have permission to edit your profile. Please request that the administrator completes your information so you can continue.',
    sign: 'Sign',
    alreadySignedAlert: 'You have already signed this form',
    rejectedAlert: 'You rejected this signature request',
    goToSignatures: 'View all Signatures',
    signatureConfigAlert: 'Please check your signature configuration',
    signSuccess: 'Form signed successfully!',
    signError: 'There was an error signing the form',
    signatureVerifySuccess:
      'You have successfully verified your electronic signature! Now you will be able to sign all your forms',
    signatureVerifyError: 'There was an error verifying your electronic signature',
    checkedCountInfo: 'selected items',
    checkedCountListInfo: 'Elements selected from a list of',
    items: 'items',
    total: 'total',
    group: 'Group',
    nestableLocationBelongsTo: 'Belongs to',
    attachedFiles: 'These are the files attached to this question',
    editAnswer: 'Edit Answer',
    editAnswerDisabled: 'You cannot edit the answer because it has a signature request',
    editAnswerNoPermission: 'You do not have permission to edit this answer',
    viewDocumentValidation: 'View Document Validation',
    qrUniqueDocumentTitle: 'Unique document QR code',
    qrUniqueDocumentDescription:
      'This document includes an electronic signature; its authenticity can be verified by scanning the QR code.',
    metadataComments: {
      item: 'Item',
      answer: 'Answer',
      description: 'Comment',
      images: 'Images',
      issues: 'Issue created',
      viewIssue: 'View issue',
    },
    expiredLink: {
      description: 'This link has expired. Request a new one by clicking the button',
      button: 'Request link',
      newLinkRequestedSuccess: 'The link has been sent to your email',
      newLinkRequestedError: 'There was an error sending the link',
    },
    externalUserSign: {
      title: 'Register your signature',
      registeredDescription:
        'Your signature is registered, please confirm your details to continue',
      unregisteredDescription:
        'Your signature is not registered; to sign, please complete the following details',
      name: 'Full name',
      company: 'Company',
      role: 'Position',
      confirm: 'Continue',
      cancel: 'Cancel',
      success: 'Form signed successfully!',
      error: 'There was an error signing the form',
    },
    rejectModal: {
      title: 'Reject request',
      subtitle: 'Enter the reason for rejecting the signature request',
      placeholder: 'Write the reason here (Required)',
      minLength: 'Minimum 5 characters',
      cancel: 'Cancel',
      confirm: 'Reject',
    },
    locationInfo: {
      title: 'Detected location information',
      description: 'The answer was detected in a location from your list of locations',
      viewInMap: 'View in map',
      nameAndDistance: 'Name and distance',
      distanceHelpIcon:
        'The location was automatically detected. The distance between the detected location and the point from where the answer was submitted is shown.',
      awayFromLocation: 'km away from the location',
      detectedByGps: 'Detected by GPS',
    },
    formatErrors: {
      warningMessage: 'There were problems displaying certain answers. Please contact support.',
      workingWarningMessage:
        'We are aware of an error in the data registration. We are working on a solution.',
      answerListTitle: 'Answers with display issues:',
    },
    signature: {
      name: 'Name',
      idNumber: {
        CL: 'RUT',
        PE: 'DNI',
        MX: 'CURP',
        CO: 'CC',
        AR: 'DNI',
        PY: 'CI',
        ES: 'DNI/NIE',
        BR: 'CPF',
        UY: 'CI',
        BO: 'CI',
        EC: 'Cedula',
        VE: 'Cedula',
        US: 'SSN',
        CA: 'SIN',
        DO: 'Cedula',
        CR: 'Cedula',
        PA: 'Cedula',
        GT: 'DPI',
        SV: 'DUI',
        HN: 'DNI',
        NI: 'Cedula',
        PR: 'SSN',
        CU: 'CI',
        JM: 'TRN',
        PT: 'NIF',
        FR: 'INSEE',
        DE: 'Tax ID',
        IT: 'Codice Fiscale',
        GB: 'National Insurance Number',
        IE: 'PPS Number',
        NL: 'BSN',
        BE: 'National Number',
        CH: 'AHV Number',
        AT: 'Social Security Number',
        SE: 'Personal Number',
        NO: 'National ID',
        DK: 'CPR Number',
        FI: 'Personal Identity Code',
        IS: 'Kennitala',
        PL: 'PESEL',
        CZ: 'Birth Number',
        SK: 'Birth Number',
        HU: 'Tax Number',
        RO: 'CNP',
        BG: 'EGN',
        GR: 'AMKA/AFM',
        HR: 'OIB',
        SI: 'EMSO',
        RS: 'JMBG',
        BA: 'JMBG',
        ME: 'JMBG',
        MK: 'EMBG',
        MT: 'ID Card',
        CY: 'ID Number',
        LU: 'National ID',
        LT: 'Personal Code',
        LV: 'Personal Code',
        EE: 'Personal Code',
        TR: 'TC Kimlik No',
        IL: 'ID Number',
        SA: 'National ID',
        AE: 'Emirates ID',
        QA: 'QID',
        KW: 'Civil ID',
        BH: 'CPR',
        OM: 'Civil ID',
        JO: 'National ID',
        LB: 'ID Number',
        EG: 'National ID',
        MA: 'CIN',
        TN: 'CIN',
        DZ: 'National ID',
        ZA: 'ID Number',
        NG: 'NIN',
        KE: 'ID Number',
        GH: 'Ghana Card',
        UG: 'National ID',
        TZ: 'NIDA',
        RW: 'National ID',
        BW: 'Omang',
        NA: 'ID Number',
        ZM: 'NRC',
        ZW: 'National ID',
        ET: 'National ID',
        CN: 'National ID',
        IN: 'Aadhaar',
        PK: 'CNIC',
        BD: 'NID',
        JP: 'My Number',
        KR: 'RRN',
        SG: 'NRIC/FIN',
        MY: 'MyKad',
        ID: 'KTP',
        PH: 'UMID',
        TH: 'National ID',
        VN: 'CCCD',
        HK: 'HKID',
        TW: 'National ID',
        LK: 'NIC',
        NP: 'National ID',
        AU: 'TFN/Medicare',
        NZ: 'IRD Number',
        RU: 'SNILS',
        UA: 'Tax Number',
        BY: 'National ID',
        KZ: 'IIN',
        UZ: 'PINFL',
        GE: 'Personal Number',
        AM: 'Social Card',
        AZ: 'FIN',
      },
      email: 'Email',
      date: 'Date',
      of: 'of',
      rejectedInfoPartial: 'rejected this document on',
      rejectedWithReason:
        '{name} rejected this document on {date} because {reason}. We invite you to make the necessary corrections to the current document and generate a new signature request.',
      rejectedWithoutReason:
        '{name} rejected this document on {date}. We invite you to make the necessary corrections to the current document and generate a new signature request.',
      weInviteYouTo: 'We invite you to',
      makeCorrections:
        'make the necessary corrections to the current document and generate a new signature request.',
    },
    backToHome: 'Back to Home',
    paywall: {
      title: 'You have reached the limit of answers. Upgrade your plan to see more',
      button: 'Upgrade plan',
      chat_message: 'Hello, I need to see more answers. How can I upgrade my plan?',
    },
    downloadPdf: 'Download PDF',
    status: 'Status',
    noStatus: 'No status',
    activityPeriodTime: {
      startTime: 'Start Time',
      endTime: 'End Time',
      activity: 'Activity',
      duration: 'Duration',
    },
  },
  electronic_signature: {
    verifySignature: 'Verify Signature',
    annex: 'Annex',
    sendCode: 'Send code',
    errorSendingCode: 'An error occurred while sending the code',
    successSendingCode: 'Code sent successfully',
    code_sent_to_email: 'We sent the verification code to your email:',
    resendCodeLabel: "Didn't receive the code?",
    resend: 'Resend',
    incorrect_code: 'Incorrect code, you have {remaining_attempts} attempts left',
    maxAttemptsReached: 'You have reached the maximum number of attempts, a new code has been sent',
    errorVerifyingCode: 'Error verifying the code',
    back: 'Back',
    share: 'Share',
    signatures: {
      title: 'My Signatures',
      signature_date: 'Signature Date',
      noPendingSignatures: 'Congratulations! You have no pending signatures at this time',
      noCompletedSignatures: 'You have no completed signatures at this time',
      selected: 'Selected',
      sign: 'Sign',
      viewAndDownload: 'View and download',
      massiveSignError: 'There was an error signing the forms',
      massiveSignSuccess: 'Forms signed successfully',
      downloadError: 'There was an error downloading the file',
    },
    documentValidation: {
      validDocumentTitle: 'Valid Document',
      formSummary: 'Form {form_name} answered by {user_name}. Response date: {answer_date}.',
      openDetails: 'Access the document details here',
      respondedByLabel: 'Answered by:',
      answerDateLabel: 'Response date:',
      signedByTitle: 'Signed by:',
      signerNameLabel: 'Name',
      signerRutLabel: 'ID',
      signerEmailLabel: 'Email',
      signerDateLabel: 'Date',
      accessRestrictionNote: 'To access the document details you must be logged in to DataScope',
      footerLegalText:
        'This document complies with the applicable regulations and its electronic signature is validated by DataScope.',
      footerOrdinanceIntro: 'Check the ordinance ',
      footerOrdinanceLinkLabel: 'here',
      footerCta: 'Digitize your documents with DataScope',
      noSigners: 'This document does not have any registered signatures yet',
      error: 'We could not validate this document. Please check the link or contact support.',
    },
    requests: {
      notifyByEmail: 'Notify via email',
      title: 'Sent Requests',
      mandatory: 'Required signature',
      optional: 'Optional signature',
      ongoing: 'Ongoing',
      completed: 'Completed',
      searchPlaceholder: 'Search by user or form...',
      form: 'Form',
      requestDate: 'Request Date',
      requestedBy: 'Requested by',
      goToSign: 'Go to sign',
      signatureDate: 'Signature Date',
      signatures: 'Signatures',
      signed: 'Signed',
      deleteRequest: 'Delete Request',
      pending: 'Pending',
      actions: 'Actions',
      deleteSuccess: 'Request deleted successfully',
      notifyByEmailSuccess: 'Users notified successfully',
      notifyByEmailError: 'There was an error notifying the users',
      deleteError: 'There was an error deleting the request',
      noOngoingRequests: 'All set! You have no ongoing requests at the moment.',
      noCompletedRequests: 'You have no completed requests at the moment.',
      shareModal: {
        title: 'Share completed signature request',
        share: 'Share',
        infoAlert:
          'A file will be sent by email. Recipients will be able to access and review the details easily.',
        emailInstruction: 'Enter the email address where you want to send the file.',
        inputInstruction: 'You can quickly add tasks by separating them with commas ",".',
        cancel: 'Cancel',
      },
      shareSuccess: 'Request shared successfully',
      shareError: 'There was an error sharing the request',
      deleteWarningTitle: 'Are you sure you want to delete this request?',
      deleteWarningMessage:
        'Signatures that have already been completed will remain valid and will be saved in the history.',
      timeline: {
        title: 'Request details',
        close: 'Close',
        createdRequired: '{user} has sent a mandatory signature request',
        createdOptional: '{user} has sent an optional signature request',
        createdRequiredSimultaneous: '{user} has sent a mandatory signature request to:',
        createdOptionalSimultaneous: '{user} has sent an optional signature request to:',
        createdRequiredSequential: '{user} has sent a mandatory signature request with this order:',
        createdOptionalSequential: '{user} has sent an optional signature request with this order:',
        signed: '{user} signed the document',
        signedOrder: '{user} signed the document ({number} signers)',
        signedOrderGroup: '{user} signed the document ({number} signers of group {group})',
        rejected: '{user} rejected the request',
        rejectReason: 'Reason',
        signatureRequested: 'Request sent to {user} ({number} signers)',
        signatureRequestedGroupSingular: 'Request sent to {users} (Signer group {group})',
        signatureRequestedGroupPlural: 'Request sent to {users} (Signers group {group})',
        completed: 'All required signatures have been completed. The document is now ready',
        signer: 'Signer',
        group: 'Group',
      },
      tooltip: {
        signed: 'Request completed',
        rejected: 'Request rejected',
      },
    },
    promo: {
      title: 'Sign reports digitally and ensure processes',
      description:
        'With the Signatures module, you can request and sign processes simply and securely.',
      actionButton: 'I want to implement Signatures!',
      moreInfoTitle: 'Ensure full traceability and minimize errors',
      infoPoint1: 'Request signatures from your field team and send automatic notifications',
      infoPoint2: 'Ensure the compliance of your processes',
      infoPoint3: 'Approved by the Labor Department (valid only in Chile)',
      infoPoint4: 'Access your data securely from any device',
      moreInfoButton: 'I want more information!',
      moreInfoLink:
        'https://help.mydatascope.com/en/articles/8728763-verified-electronic-signature',
    },
    emptyState: {
      mainBanner: {
        title: 'Sign reports digitally and ensure processes',
        description:
          'With the "Signatures" module, you can request and sign processes simply and securely.',
        actionButton: 'I want to implement Signatures!',
        actionButtonError:
          'There was an error requesting implementation. Contact support for more information.',
        actionButtonSuccess: 'Implementation requested successfully',
        actionButtonTooltipAdminUnrequested: 'Request implementation',
        actionButtonTooltipAdminRequested: 'Implementation has already been requested',
        actionButtonTooltipUser: 'Only the account administrator can perform this action',
      },
      gallery: {
        title: 'Manage legally valid signatures',
        verifySignatures: 'Verify and save staff signatures',
        verifySignaturesAlt: 'Smartphone showing signature verification on the app',
        requestSignatures: 'Request signatures on specific forms',
        requestSignaturesAlt:
          'Smartphone showing a form response and the "request signature" button on the app',
        acceptSignatures: 'Accept or reject signatures',
        acceptSignaturesAlt:
          'Smartphone showing a response with requested signature and accept/reject buttons',
        trackSignatures: 'Track the status of each signature',
        trackSignaturesAlt:
          'Smartphone showing a list of incomplete signature requests with details on the app',
        pdfSignatures: 'Get PDF reports with digital signatures',
        pdfSignaturesAlt:
          'Smartphone showing a PDF report with digital signatures included and highlighted',
      },
      requestMoreInfo: {
        title: 'Add it to your plan today!',
        description:
          'Talk to a specialist and discover how to implement the module in your organization',
        button: 'Request more information',
        link: 'https://datascope.io/en/nueva_firma/#',
      },
      newFeatures: {
        title: 'Starting today, you can use these new features!',
        preConfigTitle: 'Preconfigure signers',
        preConfigDescription:
          'Predefine who must sign your documents to automate recurring workflows and save time.',
        externalSignatureTitle: 'Request signatures from external users',
        externalSignatureDescription:
          'Invite collaborators outside your organization to sign securely, without needing a DataScope account.',
        sequentialSignatureTitle: 'Configure signature sequence',
        sequentialSignatureDescription:
          'Set a predefined signing order for documents involving multiple signers with different levels of authority.',
      },
    },
    activation: {
      processTitle: 'Your Signatures module activation request is already in process!',
      processMessage:
        'A representative from our team will contact you to explain the details of the Signatures module activation process.',
      stepsTitle: 'Next steps',
      step1Title: 'Signatures module implementation request entered successfully.',
      step2Title: 'A specialist from DataScope will contact you.',
      step2Description: 'Maximum 1 business day',
      step3Title: 'Presentation of the Signatures module.',
      step3Description: 'Date to coordinate with the specialist',
      step4Title: 'Activation of the Signatures module',
      step4Description: 'You will be able to access it from this same tab!',
    },
  },
  resume: {
    stats: {
      assignedTasks: 'Assigned Tasks',
      completedTasks: 'Completed tasks',
      forms: 'Forms',
      totalForms: 'Total answered',
      locations: 'Visited Locations',
      totalLocations: 'Total locations',
      signatures: 'Signatures',
      completedSignatures: 'Completed signatures',
      findings: 'Issues',
      closedFindings: 'Closed issues',
      previousDays: 'previous days',
    },
    emptyState: {
      description:
        "You haven't answered any form yet! Start optimizing your processes by creating the first one",
      createFirstForm: 'Create a form now',
    },
    statuses: {
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      noStatus: 'No Status',
    },
    table: {
      configure: 'Configure',
      viewAnswer: 'View Answer',
      form: 'Form',
      code: 'Code',
      user: 'User',
      date: 'Date',
      status: 'Status',
      actions: 'Actions',
      changeLog: 'Change Log',
      modifyAnswer: 'Modify Answer',
      chat: 'Chat',
      sendToGoogleSheets: 'Send to Google Sheets',
      sendBackupToEmail: 'Send backup to email',
      downloadPdf: 'Download PDF',
      duplicateAnswer: 'Duplicate Answer',
      statusUpdateError: 'There was an error updating the status of the answer',
      noResults: 'No form answers found that match the applied filters',
      deleteAnswer: 'Delete',
      recoverAnswer: 'Recover',
    },
    bulkActions: {
      delete: 'Delete',
      changeStatus: 'Change Status',
      selected: 'selected',
      confirmDelete: 'Are you sure you want to delete {count} form answers?',
      confirmDeleteDescription: 'Once deleted, they will not be recoverable',
      cancel: 'Cancel',
      selectStatus: 'Select Status',
      select: 'Select',
      statuses: 'Statuses',
      selectStatusPlaceholder: 'Select a status',
      statusesUpdated: 'Statuses updated successfully!',
      errorUpdatingStatuses: 'Error updating statuses',
      deleteSuccess: 'Answers deleted successfully!',
      deleteError: 'Error deleting answers',
      recover: 'Recover',
      recoverSuccess: 'Answers recovered successfully!',
      recoverError: 'Error recovering answers',
    },
    filters: {
      addFilter: 'Add Filter',
      clearFilters: 'Clear Filters',
      dateRange: {
        title: 'Date',
        popoverTitle: 'Filter by date',
      },
      location: {
        title: 'Location',
        popoverTitle: 'Filter by location',
        noLocations: 'No locations found',
      },
      form: {
        title: 'Form',
        popoverTitle: 'Filter by form',
        inactive: 'Inactive',
        deleted: 'Deleted',
        folders: 'Folders',
        forms: 'Forms',
        noForms: 'No forms found',
      },
      status: {
        title: 'Status',
        popoverTitle: 'Filter by status',
      },
      user: {
        title: 'User',
        popoverTitle: 'Filter by user',
        allTab: 'Users',
        groupTab: 'Groups',
        noUsers: 'No users found',
        noGroups: 'No groups found',
      },
      formCode: {
        title: 'Form Code',
        popoverTitle: 'Filter by form code',
        placeholder: 'Enter form code',
      },
      questionAndAnswer: {
        title: 'Question and Answer',
        popoverTitle: 'Filter by question and answer',
        questionLabel: 'Question',
        questionPlaceholder: 'Select a question',
        questionTextInputPlaceholder: 'Write the question name',
        answerLabel: 'Answer',
        answerDisabledPlaceholder: 'Select a question to activate the filter',
        answerTextInputPlaceholder: 'Write a question name to activate the filter',
        answerPlaceholder: 'Write the answer',
        info: 'The filter will only apply if there is a question and an answer',
        disabledTooltip: 'To use this filter, you must first add a form filter',
      },
      finding: {
        title: 'Issue',
        popoverTitle: 'Filter by issue',
        includesFinding: 'Includes issue',
        withoutFindings: 'Without issues',
      },
      signature: {
        title: 'Signature',
        popoverTitle: 'Filter by signature',
      },
      answeredFrom: {
        title: 'Answered from',
        popoverTitle: 'Filter by answered from',
        mobile: 'Mobile',
        web: 'Web',
      },
      assets: {
        title: 'Assets',
        popoverTitle: 'Filter by assets',
        noAssets: 'No assets found',
      },
    },
    signature: {
      mandatoryIncomplete: 'Mandatory signature - Incomplete',
      mandatoryComplete: 'Mandatory signature - Complete',
      optionalIncomplete: 'Optional signature - Incomplete',
      optionalComplete: 'Optional signature - Complete',
    },
    recentTitle: 'Recent answers',
    deletedTitle: 'Deleted answers',
    searchBarPlaceholder: 'Search...',
    dateRange: 'Showing results for',
    changeLog: {
      title: 'Change Log',
      details: 'View details',
      userChangedAnswer: '{user} changed the answer',
      userChangedState: '{user} changed the status of the answer to {state}',
      userRecoveredAnswer: '{user} recovered the answer',
      userDeletedAnswer: '{user} deleted the answer',
      userDuplicatedAnswer: '{user} duplicated the answer',
      userStartedAnswer: '{user} started to answer',
      userResetState: '{user} reset the status of the answer',
    },
    close: 'Close',
    export: {
      title: 'Export',
      taskForm: 'Form',
      dateRange: 'Date range',
      downloadFormat: 'Download format',
      email: 'Email',
      downloadFormats: {
        answers: 'Excel grouped by answer',
        forms: 'Excel grouped by form',
        subforms: 'Excel grouped by repeatable fields',
        pdfs: 'PDF documents',
      },
      exportInfo: 'The answers will be exported according to the table filters',
      exportFormFilterRequired: 'To export the answers, you must first filter by form',
      exportDateRangeLimit: 'Export limit: 180 days (6 months). Select a shorter date range',
      cancel: 'Cancel',
      success: 'Export sent successfully',
      error: 'There was an error exporting the answers',
      disabledForFreeUser: 'Update your plan to enable data export',
    },
    sendToGoogleSheets: {
      success: 'Sent to Google Sheets successfully',
      error: 'There was an error sending the answer to Google Sheets',
      gsheetBusy: 'Google Sheets is busy right now. Please wait a few minutes and try again.',
      integrationError:
        'Could not send to Google Sheets. Check your Google Sheets integration (permissions, formulas and spreadsheet link).',
      unknownError:
        'An unknown error occurred while sending to Google Sheets. Please try again later.',
      sendModifyConfirmTitle: 'This answer has already been sent to Google Sheets',
      sendModifyConfirmMessage:
        'This integration does not have the edit sync feature enabled. Re-sending manually may create duplicate rows in the spreadsheet. Do you want to continue anyway?',
      sendModifyConfirmButton: 'Yes, send anyway',
    },
    duplicateAnswer: {
      success: 'Answer duplicated successfully!',
      error: 'Error duplicating answer',
    },
    sendBackupModal: {
      title: 'Send backup to email',
      description: 'Write the email where you want to receive the backup of this form',
      send: 'Send',
      cancel: 'Cancel',
    },
    deleteAnswer: {
      title: 'Are you sure you want to delete this answer?',
      description:
        'Once deleted, it will not be recoverable. You can recover it by filtering by deleted answers and restoring it from its configuration.',
      confirm: 'Delete',
      cancel: 'Cancel',
      success: 'Answer deleted successfully!',
      error: 'Error deleting answer',
    },
    recoverAnswer: {
      success: 'Answer recovered successfully!',
      error: 'Error recovering answer',
    },
    statusSelector: {
      newStatus: 'Select or create a status',
      newStatusPlaceholder: 'Write here the new status',
      newStatusError: 'The status already exists',
      delete: 'Delete',
      color: 'Color',
      colors: {
        white: 'White',
        blue: 'Blue',
        yellow: 'Yellow',
        red: 'Red',
        green: 'Green',
        gray: 'Gray',
      },
      editStatusError: 'Error updating status',
      deleteStatusError: 'Error deleting status',
      createStatusError: 'Error creating status',
      deleteConfirmationTitle: 'Are you sure you want to delete this status?',
      deleteConfirmationMessage:
        'Once deleted, it will not be recoverable. But the answers that use it will not be affected.',
    },
    chat: {
      notifyUsersError: 'Error notifying users',
    },
    filtersLinkCopy: {
      tooltip: 'Copy link with filters',
      success: 'Link copied to clipboard',
      error: 'Could not copy link. Check browser permissions.',
    },
    answerView: {
      previous: 'Previous',
      next: 'Next',
    },
  },
  assets: {
    title: 'Assets',
    assetsSearchPlaceholder: 'Search by asset name or code',
    historySearchPlaceholder: 'Search by asset name, code or user',
    noAssets: 'No assets found.',
    noAssetMeters: 'There are no meters configured for this asset',
    noHistory: 'No history found.',
    create: 'Create',
    update: 'Update',
    createAsset: 'Create Asset',
    name: 'Name',
    configuration: 'Configuration',
    addUsers: 'Add users',
    showAll: 'Show all ({count})',
    showLess: 'Show less',
    usersAssignedSuccess: 'Users assigned successfully',
    usersAssignedError: 'Error assigning users',
    history: 'History',
    code: 'Code',
    dateAndTime: 'Date and Time',
    asset: 'Asset',
    modifiedField: 'Modified Field',
    modification: 'Modification',
    modifiedBy: 'Modified By',
    createNewAsset: 'Create new asset',
    editAsset: 'Edit asset',
    assetInformation: 'Asset information',
    metersDescription: 'Link and manage the meters of each asset to register readings accurately',
    namePlaceholder: 'Asset name',
    codePlaceholder: 'Serial number, plate or unique ID',
    location: 'Location',
    locationPlaceholder: 'Select a location',
    restrictAccess: 'Restrict access to this asset to specific users',
    usersAndGroups: 'Users and groups',
    description: 'Description',
    descriptionPlaceholder: 'Write a description for the asset',
    meterType: 'Meter type',
    meterTypePlaceholder: 'Select a meter type',
    meter: 'Meter',
    lastMeasurement: 'Last Measurement',
    lastSyncedMeasurement: 'Last synced measurement: ',
    lastMeasurements: 'Last Measurement(s)',
    actions: 'Actions',
    viewDetails: 'View details',
    edit: 'Edit',
    delete: 'Delete',
    edited: 'Edited',
    editedBy: 'Edited by',
    previousValue: 'Previous value',
    confirmDeleteTitle: 'Are you sure you want to delete this asset?',
    confirmDeleteDescription:
      'The asset {assetName} will be deleted, but the data registered previously will be preserved.',
    cancel: 'Cancel',
    assetCreated: 'Asset created successfully',
    assetRestored: 'Asset restored',
    assetUpdated: 'Asset updated successfully',
    assetDeleted: 'Asset deleted successfully',
    assetDeletedError: 'Error deleting asset',
    activate: 'Activate',
    deactivate: 'Deactivate',
    assetDeactivated: 'Asset deactivated successfully',
    assetDeactivatedError: 'Error deactivating asset',
    assetReactivated: 'Asset reactivated successfully',
    assetReactivatedError: 'Error reactivating asset',
    confirmDeactivateTitle: 'Are you sure you want to deactivate this asset?',
    confirmDeactivateDescription:
      'The asset {assetName} will be deactivated. It will still appear in the table but with limited access.',
    assetUpdatedError: 'Error updating asset',
    noAssetPermissions: 'You do not have permissions to view assets',
    assetCreatedError: 'Error creating asset',
    meterCreated: 'Meter created successfully',
    meterUpdated: 'Meter updated successfully',
    meterDeleted: 'Meter deleted successfully',
    meterDeactivated: 'Meter deactivated successfully',
    meterDuplicated: 'Meter duplicated successfully',
    assetLimitReachedError:
      'Asset limit reached. You cannot create more assets with your current plan.',
    assetCodeAlreadyExists: 'Asset code already exists',
    assetInfo: 'Asset Information',
    export: 'Export',
    import: 'Import',
    editTableColumns: 'Customize columns',
    selectedCount: '{count} selected',
    changeTypeButton: 'Change asset type',
    changeTypeTitle: 'Change asset type',
    changeTypeInfo: 'It will replace the current type of the selected assets',
    changeTypeApply: 'Add',
    changeTypeSearchPlaceholder: 'Search an asset type',
    confirmChangeTypeTitle: 'Are you sure you want to change the type of the selected assets?',
    confirmChangeTypeMessage:
      'The custom fields on the selected assets will no longer be visible, but the information will remain recorded.',
    usersAndGroupsTooltip:
      'You must assign at least one user so they can view and manage this asset. If you do not select any, no one will have access.',
    v1MetersDescription: 'Currently, we only support Hour meters.',
    addUsersDescription:
      'The selected users will have access to this asset to view and manage it according to their permissions.',
    findOutMore: 'Find out more',
    findOutMoreLink: '',
    betaBannerTitle: 'Assets is in Beta',
    betaBannerDescription:
      'We are working on the full version, which will include properties, meters and locations. Soon available in paid plans.',
    moreInfo: 'More info',
    viewMeasurements: 'View measurements',
    noMeasurements: 'No measurements',
    noData: 'No data',
    initialMeasurementPlaceholder: 'Enter the initial value',
    initialMeasurementsTitle: 'Initial meter measurements',
    initialMeasurementsDescription: 'Define the initial value for each meter of this asset',
    initialMeasurementTooltip:
      'This is the initial value defined when creating the asset. To update it, record a new measurement.',
    summaryTitle: 'Summary',
    noAssetTypeSelected: 'No asset type selected',
    noMeters: 'No meters',
    fieldRequired: 'This field is required',
    inactive: 'Inactive',
    inactiveMeterTooltip:
      'This meter is inactive for the current asset type. You can view previous readings. To activate it, add it to the asset type or change the asset type.',
    blockedAssetTooltip:
      'This asset is blocked by plan limit. Upgrade your plan to access the details.',
    blockedAssetHistoryTooltip:
      'This asset is blocked by plan limit. Upgrade your plan to access the history.',
    assetStatus: 'Asset status',
    changeTypes: {
      asset_created: 'Asset created',
      asset_deleted: 'Asset deleted',
      asset_deactivated: 'Asset deactivated',
      asset_reactivated: 'Asset reactivated',
      asset_revived: 'Asset restored',
      asset_updated_by_import: 'Asset updated by import',
      added_user: 'Assigned user(s)',
      removed_user: 'Removed user(s)',
      added_group: 'Assigned group(s)',
      removed_group: 'Removed group(s)',
      added_meter: 'Assigned meter(s)',
      removed_meter: 'Removed meter(s)',
      name: 'Name changed',
      code: 'Code changed',
      description: 'Description changed',
      asset_type: 'Asset type changed',
      nestable_location: 'Location changed',
    },
    importDrawer: {
      title: 'Import Assets',
      step1Title: 'Step 1: Download template',
      step1Description:
        'Download the Excel template example. Each sheet corresponds to an asset type. Make sure to complete the fields marked with * to import your file correctly.',
      step1DescriptionPart1:
        'Download the Excel template example. Each sheet corresponds to an asset type. Make sure to complete the fields marked with',
      step1DescriptionPart2: 'to import your file correctly.',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Edit the file',
      step3Title: 'Step 3: Upload your file',
      step3Description: 'Drag and drop your file here or select it from your computer.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importSuccess: 'Assets imported successfully',
      importError: 'Error importing assets',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      importingDescription: 'Just a moment, we are organizing everything...',
      errorTitle: 'We detected an error.',
      errorMessage: 'Please check that your data has the correct format.',
      sheetsWithErrorsMessage: 'The file contains errors in the sheets: ',
      sheetsWithErrorsRecommendation:
        'Review the indicated sheets and correct the data to continue.',
      andMore: 'and {remainingCount} more',
      nameErrorMessage: '{errorCount} rows were submitted without asset name.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      showMore: 'Show {count} more',
      showLess: 'Show less',
      errorsListTitle: 'Issues found',
      rowLabel: 'Row',
      formatLabel: 'Format',
      summary: {
        created: '{count} asset(s) created',
        restored: '{count} asset(s) restored',
        updated: '{count} asset(s) updated',
      },
    },
    googleSheets: {
      button: 'Google Sheets',
      modalTitle: 'Integrate Assets',
      infoMessage: 'For a secure integration, share your document with',
      editorPermission: 'editor',
      infoMessageTo: 'permissions to',
      linkLabel: 'New link',
      linkPlaceholder: 'Enter the document link to integrate',
      goToSheets: 'Go to Google Sheets',
      copied: 'Link copied',
      copyError: 'Unable to copy the link. Try copying it manually.',
      deleted: 'Google Sheets integration deleted successfully',
      deleteError: 'Error deleting Google Sheets integration',
      deleteConfirmTitle: 'Remove Google Sheets integration?',
      deleteConfirmMessage:
        'Your spreadsheet will no longer receive asset updates from DataScope. The document in Google Drive is not deleted.',
      deleteConfirmAction: 'Remove',
      cancel: 'Cancel',
      save: 'Save',
      success: 'Google Sheets integration created successfully',
      error: 'Error creating Google Sheets integration',
    },
    exportSuccess: 'Assets exported successfully',
    exportError: 'Error exporting assets',
    exporting: 'Exporting...',
    exportModal: {
      title: 'Export Assets',
      assetTypesLabel: 'Select the asset types to export',
      assetTypesPlaceholder: 'Select asset types',
      selectAll: 'Select all asset types',
      confirm: 'Export',
      cancel: 'Cancel',
      infoBanner: 'The export will only include asset types that have assets associated.',
    },
    origin: 'Source',
    meters: {
      title: 'Meters',
      subtitle: 'Manage the meters available for your assets',
      create: 'Create',
      createMeter: 'Create meter',
      editMeter: 'Edit meter',
      deactivateMeter: 'Deactivate meter',
      backToAssets: 'Back to Assets',
      cancel: 'Cancel',
      update: 'Update',
      metersSearchPlaceholder: 'Search by meter name',
      noResults: 'No results',
      table: {
        name: 'Name',
        unit: 'Unit of Measure',
        usage: 'Usage',
        actions: 'Actions',
        usedInAssetTypes: 'Used in {count} type(s)',
        notUsed: 'Not used',
        edit: 'Edit',
        duplicate: 'Duplicate',
        deactivate: 'Deactivate',
        activate: 'Activate',
      },
      pagination: {
        results: 'Results: {start}-{end} of {total}',
      },
      noMeters: 'No meters found',
      confirmDeactivateDescription:
        'The meter {meterName} will be deactivated. When deactivated, it will no longer be available for new assets. If you wish, you can activate it again later.',
      meterInUseError:
        'Cannot deactivate meter that is currently used in asset types. Please remove it from asset types first.',
      deactivationDisabled:
        'This meter cannot be deactivated because it is currently in use by one or more asset types. Please remove it from asset types first.',
      units: {
        hour: 'Hour',
        minute: 'Minute',
        seconds: 'Second',
        day: 'Day',
        mile: 'Mile',
        kilometer: 'Kilometer',
        meter: 'Meter',
        foot: 'Foot',
        yard: 'Yard',
        inch: 'Inch',
        centimeter: 'Centimeter',
        millimeter: 'Millimeter',
        nautical_mile: 'Nautical Mile',
        celsius: 'Celsius',
        fahrenheit: 'Fahrenheit',
        kelvin: 'Kelvin',
        volt: 'Volt',
        megavolt: 'Megavolt',
        kilovolt: 'Kilovolt',
        millivolt: 'Millivolt',
        microvolt: 'Microvolt',
        bar: 'Bar',
        pascal: 'Pascal',
        psi: 'PSI',
        kilogram: 'Kilogram',
        ton: 'Ton',
        pound: 'Pound',
        kilometer_per_hour: 'Kilometer per Hour',
        mile_per_hour: 'Mile per Hour',
        meter_per_second: 'Meter per Second',
        newton_meter: 'Newton Meter',
        pound_foot: 'Pound Foot',
        liter: 'Liter',
        gallon: 'Gallon',
        cubic_meter: 'Cubic Meter',
        cubic_foot: 'Cubic Foot',
        rpm: 'RPM',
        hertz: 'Hertz',
        watt: 'Watt',
        kilowatt: 'Kilowatt',
        ampere: 'Ampere',
        square_meter: 'Square Meter',
        square_foot: 'Square Foot',
        hectare: 'Hectare',
        farad: 'Farad',
        ohm: 'Ohm',
        siemens: 'Siemens',
        lux: 'Lux',
        radian_per_second: 'Radian per Second',
        coulomb: 'Coulomb',
        unit: 'Unit',
      },
      assetTypeModal: {
        title: 'Asset types linked to ',
        description: 'This meter is linked to the following asset types:',
        close: 'Close',
      },
    },
    value: 'Value',
    assetsCreated: 'assets created',
    duplicatesSkipped: 'duplicates skipped',
    errorsCount: 'errors',
    readings: 'Readings',
    configure: 'Configure',
    initialMeasurement: 'Initial measurement',
    measurementUpdated: 'Edited successfully',
    measurementUpdatedError: 'Error editing',
    measurementDeleted: 'Deleted successfully',
    measurementDeletedError: 'Error deleting',
    confirmDeleteMeasurementTitle: 'Are you sure you want to delete this measurement?',
    confirmDeleteMeasurementDescription:
      'This action is permanent and the measurement will no longer appear in the table.',
    mustEnterNumber: 'You must enter a number',
    action: 'Action performed',
    newValue: 'New value',
    measurements: 'Measurements',
    historyTitle: 'Change history',
    deleted: 'Deleted',
    measurementsHistoryEmptyState: "This meter's measurements have not been modified yet",
    formCustomFieldsLabel: 'Asset Details',
    imageDragDropText: 'Drag and drop an image here',
    filesDragDropText: 'Drag and drop files here',
    uploadFileError: 'Error uploading file',
    assetLimitReachedTitle: 'Asset limit reached',
    assetLimitReachedDescription:
      'You have reached the asset limit in your plan. To add or manage more assets, upgrade your plan and get access to more features:',
    assetLimitFeature1: 'More assets available',
    assetLimitFeature2: 'Complete asset history',
    assetLimitFeature3: 'Complete asset information',
    assetLimitUpgradeButton: 'Unlock more assets now',
    assetLimitContinueButton: 'Continue with my current plan',
    limitedFeaturesAlert:
      'Some features are not available in your current plan. Upgrade your plan to see all assets and their measurements.',
    changePlan: 'Change plan',
    landing: {
      headerTitle: 'Start managing your assets in one place',
      headerSubtitle: 'What are assets for?',
      headerBullet1Bold: 'Customize fields by asset type: ',
      headerBullet1: 'define what data you need and create fields for each type of asset.',
      headerBullet2Bold: 'Easily link multiple meters: ',
      headerBullet2: 'assign one or more meters to each asset type according to your needs.',
      headerBullet3Bold: 'Centralized resource management: ',
      headerBullet3:
        'create and organize your assets from a single platform, viewing key information such as status, location, and meter readings.',
      headerButton: 'Use assets',
      carouselTitle: 'Create your first asset',
      carouselStep1Title: 'Create asset type',
      carouselStep1Description:
        'Create an asset type and define a category for your assets, like Equipment or Vehicles. Then you can ',
      carouselStep1DescriptionBold: 'customize the fields each asset should have.',
      carouselStep2Title: 'Select meters',
      carouselStep2Description: 'Choose the meters you want to use for this asset type, such as ',
      carouselStep2DescriptionBold:
        'hour meter, mileage, temperature or create new ones if needed.',
      carouselStep3Title: 'Create your first asset',
      carouselStep3Description: 'After configuring the asset type, press ',
      carouselStep3DescriptionBold: 'Create asset',
      carouselStep3DescriptionEnd: ' and complete the corresponding information.',
      carouselStep4Title: "Can't find the meter you need?",
      carouselStep4Description:
        'If the meter you need is not available, you can create it from the ',
      carouselStep4DescriptionBold: 'Meters tab.',
      carouselNext: 'Next',
      carouselPrevious: 'Previous',
      footerTitle: 'Organize, measure, and manage',
      footerDescription:
        'Now that you know how assets work, create an asset type, customize its information, and start linking them to your forms and readings.',
      footerButton: 'Create asset type',
    },
    assetTypes: {
      title: 'Asset Types',
      noAssetType: 'No asset type selected',
      noAssetTypes: 'No asset types found',
      create: 'Create',
      createAssetType: 'Create Asset Type',
      createAssetTypeSuccess: 'Asset type created successfully',
      createAssetTypeError: 'Error creating asset type',
      createAssetTypeErrorDuplicateName: 'Asset type name already exists',
      type: 'Asset Type',
      description: 'Description',
      createdAssets: 'Created Assets',
      actions: 'Actions',
      confirmDeleteTitle: 'Are you sure you want to delete this asset type?',
      confirmDeleteDescription:
        'The asset type {assetTypeName} will be deleted. This action cannot be undone.',
      assetTypeDeleted: 'Asset type deleted successfully',
      assetTypeDeletedError: 'Error deleting asset type',
      searchPlaceholder: 'Search asset type',
      viewAssets: 'View assets',
      assetTypeDeleteSuccess: 'Asset type deleted successfully',
      assetTypeDeleteError: 'Error deleting asset type',
      assetTypeUpdateSuccess: 'Asset type updated successfully',
      assetTypeUpdateError: 'Error updating asset type',
      formTitleEdit: 'Edit Asset Type',
      formSubtitleCreate: 'Provide details for every asset type attribute.',
      formSubtitleEdit: 'Update the asset type attributes and save your changes.',
      formNameLabel: 'Name',
      formDescriptionLabel: 'Description',
      formCustomIdLabel: 'Custom ID Name',
      formIconLabel: 'Icon',
      formLoadError: 'Unable to load this asset type.',
      formBackToList: 'Back to Asset Types',
      formReset: 'Reset',
      formSave: 'Save',
      formCancel: 'Cancel',
      formMeterSelectLabel: 'Select a meter',
      formCustomIdTooltip:
        'For a better experience, your assets should have a unique identifier. Call it whatever you want: ID, Plate, Serial, etc',
      iconSelectorColors: 'Colors',
      iconSelectorIcons: 'Icons',
      addMeterTitle: 'Add Meter',
      addMeterDescription:
        'Add meters according to the use of your asset. You can edit them when you need them',
      addMeterPlaceholder: 'Select a meter for your asset type',
      addFieldsTitle: 'Add Custom Fields',
      addFieldsDescription: 'Define the fields that will appear in the asset creation form',
      addFieldButton: 'Add field',
      requiredField: 'Required field',
      backToAssets: 'Back to Assets',
      fieldNameAlreadyExists: 'Field name already exists',
      reachedAssetTypeFieldsLimit:
        'You have reached the maximum number of fields for an asset type',
      selectType: 'Select an asset type',
      search: 'Search asset types...',
      fieldTypes: {
        text: 'Text',
        number: 'Number',
        date: 'Date',
        image: 'Image',
        files: 'Files',
      },
      fileTypeSelector: {
        label: 'File Type',
        allFormats: 'All formats',
        audio: 'Audio',
        video: 'Video',
      },
    },
  },
  mainMenu: {
    home: 'Home',
    forms: 'Forms',
    integrations: 'Integrations',
    taskAssigner: 'Task Assignments',
    findings: 'Issues',
    signatures: 'Signatures',
    lists: 'Lists',
    locations: 'Locations',
    assets: 'Assets',
    charts: 'Charts',
    map: 'Map',
    sensors: 'Sensors',
    training: 'Training',
    settings: {
      main: 'Settings and help',
      changelog: 'Alerts',
      account: 'Accounts settings',
      users: 'Users',
      billing: 'Billing',
      invite: 'Invite',
      helpCenter: 'Help center',
      news: 'News',
      upgrade: 'Upgrade',
    },
    new: 'New',
    askDataScope: 'Ask DataScope',
    myDashboards: 'My Dashboards',
  },
  dashboards: {
    title: 'My Dashboards',
    empty: 'No dashboards saved yet.',
    emptyHint: 'Ask for a chart in Ask DataScope and save it here.',
    delete: 'Delete dashboard',
    refresh: 'Refresh',
    loading: 'Loading...',
    loadError: 'Could not load dashboards.',
    addTo: 'Add to My Dashboards',
    viewIn: 'View in My Dashboards',
    saving: 'Saving...',
    saveError: 'Error saving',
    noDataToSave: 'No data to save',
    updatedAt: 'Updated',
    back: 'Back',
  },
  askDataScope: {
    title: 'Ask DataScope',
    placeholder: 'Ask anything about your data...',
    newChat: 'New Chat',
    modules: {
      all: 'All',
      forms: 'Forms',
      tasks: 'Tasks',
      locations: 'Locations',
      assets: 'Assets',
      signatures: 'Signatures',
      tickets: 'Issues',
    },
    errors: {
      timeout: 'Request timed out. Please try again.',
      rateLimit: 'Daily message limit reached.',
      generic: 'Something went wrong. Please try again.',
    },
    typing: 'Thinking...',
    readOnly: 'I can only help you query data. I cannot make changes.',
    greeting: 'Hello',
    howCanIHelp: 'How can I help you today?',
    suggestions: 'Suggestions',
    recentChats: 'Recent chats',
    noRecentChats: 'No recent conversations.',
    moduleLockedNote:
      'Module filter is fixed for this conversation. Start a new chat to change it.',
    dateFilter: {
      from: 'From',
      to: 'To',
      clear: 'Clear',
      selectRange: 'Select date range',
    },
    prompts: [
      'Summarize the answers from [form name]',
      'Create a chart with form answers per month',
      'How many signatures are still pending?',
      'Show me all tasks completed this month',
      'Give me a general overview of my account stats',
    ],
    report: {
      buttonInline: 'Report this issue',
      title: 'Report an issue',
      description: "Tell us what went wrong or what you'd like to see.",
      defaultText: 'I would like to request a feature',
      yourQuestion: 'Your question:',
      cancel: 'Cancel',
      send: 'Send report',
      sending: 'Sending...',
      successDescription: "Thank you for your feedback. We'll look into it.",
      close: 'Close',
    },
    trial: {
      title: 'Free trial',
      description:
        'Explore Ask DataScope at no cost. Ask questions about your data in natural language and get answers in seconds.',
      expired: 'The free trial has ended.',
      feedback:
        "Your feedback helps us improve it. Use the {icon} icon next to any answer to tell us what you'd change.",
      timeRemaining: 'Time remaining:',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Min',
      seconds: 'Sec',
      gotIt: 'Start exploring',
      expiredDismiss: 'Got it',
    },
    aiDisclaimer: 'This feature uses AI. Verify the data before making decisions.',
  },
  mainTopBar: {
    createIssue: 'Create issue',
    featureRequest: 'Send us your idea!',
    featureRequestText: 'Do you need a tool that we dont have yet?',
    logout: 'Logout',
    languageOptions: {
      es: 'Spanish',
      en: 'English',
      pt: 'Portuguese',
    },
    newNotifications: 'New message in {formName}',
    companySettings: 'Company settings',
    myAccount: 'My account',
  },
  notFound: {
    title: '404',
    description:
      'Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.',
    button: 'Go to home',
  },
  actionsOverview: {
    title: 'Monthly actions available',
    explanation: 'What are actions?',
    actionsUsed: 'Actions used',
    exceedActionsInfo:
      'If you exceed the number of actions included in your plan, an additional charge will be applied for each one.',
    moreInfo: 'More info',
    error: 'Error loading actions information',
    explanationLink:
      'https://help.mydatascope.com/en/articles/11321884-datascope-plans-how-do-they-work-and-what-s-included#h_dff3b3e159',
    moreInfoLink:
      'https://help.mydatascope.com/en/articles/11321884-datascope-plans-how-do-they-work-and-what-s-included#h_2f5fc832f3',
  },
  billing: {
    externalIframe: {
      tokenAuthorizeError: 'We could not authorize your session. Please refresh the page.',
    },
  },
  maps: {
    title: 'Find your answers on the map',
    emptyState: {
      title: 'Map your answers easily',
      subtitle: 'What is the purpose of the maps function?',
      description: 'With this functionality it is possible:',
      feature1:
        'Visualize in real time where forms are completed, tasks are executed or issues are reported.',
      feature2: 'Detect areas with low or high coverage to make strategic operational decisions.',
      feature3: 'Get traceability and geographic control of daily operations.',
      demo: {
        title: 'Visualize your answers on the map',
        mobile: {
          title: 'Answer from the field with the app',
          description:
            'Answer from the app with GPS enabled and validate that the answers were sent from the assigned location.',
          description2:
            'Important! Ensure that your team registers answers using the app with location enabled.',
        },
        web: {
          title: 'Visualize your answers on the map',
          description:
            'Once you have answered your forms from the App you can visualize your answers on an interactive map.',
        },
      },
    },
  },
  lists: {
    banner: {
      message:
        'New Locations are now available! Now you can organize, assign users and visualize activity in one place.',
      action: 'Try now',
    },
  },
  mfa: {
    title: 'Enable 2FA',
    next: 'Next',
    finish: 'Finish',
    close: 'Close',
    scanQr: 'Scan QR code',
    scanQrDescription:
      'Scan the QR code with your preferred authentication app',
    manualEntry: 'Or enter the code manually',
    verifying: 'Verifying...',
    verifyCode: 'Enter the authentication code',
    verifyCodeDescription: 'Write the 6-digit code that appears in your authentication app',
    verifyCodeInvalid: 'Invalid code. Try again.',
    verifyCodeError: 'Error verifying the code',
    verifyCodeCognitoError:
      'We had an internal error. Please contact us through the chat to solve it.',
    successTitle: 'Authentication configured successfully',
    successDescription:
      'From now on, each time you log in, you will be asked for a temporary code from your authentication app for greater security',
    successDescriptionMobile: 'To continue, please close the DataScope app and open it again.',
    maybeLater: 'Maybe later',
    activateNow: 'Activate now',
    protectAccount: 'Protect your account with an extra layer of security',
    protectAccountDescription:
      'With two-factor authentication, you will need a temporary code from your authenticator app to log in. You can manage this setting later from your user profile.',
    organizationRequires: 'Your organization requires activating two-factor authentication (2FA)',
    organizationRequiresDescription:
      'Use an authenticator app to generate the temporary code that will be asked when you log in',
    userSettings: {
      title: 'Account security (2FA)',
      descriptionActive:
        'Add an extra layer of security to your account.\n When you activate two-factor authentication (2FA), you will be asked for a code from your authenticator app when you log in.',
      descriptionDisable:
        'You have two-factor authentication enabled. To log in, you need a temporary code from your authentication app.\n You can disable it, but your account will be less secure.',
      activate: 'Enable 2FA',
      disableConfig: 'Disable 2FA',
      disableDialogTitle: 'Are you sure you want to disable two-factor authentication?',
      disableDialogDescription:
        'If you disable it, your account will be less secure. You can enable it again whenever you want.',
      disableDialogConfirm: 'Disable',
      disableDialogCancel: 'Cancel',
      justSameUserCanActivate: 'Only the same user can activate two-factor authentication (2FA)',
    },
  },
  scheduledSend: {
    sendNow: 'Send now',
    sameDay: 'At task start',
    dayBefore: 'day before',
    daysBefore: 'days before',
    weekBefore: '1 week before',
    monthBefore: '1 month before',
    blockTitle: 'Schedule task send',
    blockDescription:
      'Define how many days before the task starts it will be sent to the responsible',
    statsLabel: 'Scheduled',
    scheduled: 'Scheduled',
    onboardingModal: {
      title: 'You can now schedule task delivery',
      description:
        'You can now decide when the operator will receive the task: on the same day or in advance, to improve planning and execution.',
      primaryButton: 'Got it',
      secondaryButton: 'Learn how it works',
      helpCenterUrl:
        'https://help.mydatascope.com/en/articles/14536340-scheduling-of-assigned-tasks',
    },
    tooltip: {
      sendNow: 'The task will be sent today',
      sameDay: 'The task will be sent at task start',
      nDaysBefore: 'The task will be sent on {{dates}}',
      sentOn: 'The task was sent on {{dates}}',
      disabledSingular: '{{count}} selected date does not allow scheduling this send: {{dates}}',
      disabledPlural: '{{count}} selected dates do not allow scheduling this send: {{dates}}',
      noStartDate: 'Select at least one start date and time',
    },
  },
};
